//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? "";
  }

  /**
   * Получение истории действий, связанных с транспортными средствами
   * @param userId (optional) Идентификатор пользователя
   * @param dataId (optional) Id данных
   * @param actionType (optional) Тип действия
   * @return Возвращает сообщение об успехе, если удалось получить список действий и сам список
   */
  getVehicleActions(
    userId: string | undefined,
    dataId: string | undefined,
    actionType: ActionType | undefined
  ): Promise<VehicleDTOActionHistoryDTOListResponseDTO> {
    let url_ = this.baseUrl + "/admin/action-history/get-vehicle-actions?";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (dataId === null)
      throw new Error("The parameter 'dataId' cannot be null.");
    else if (dataId !== undefined)
      url_ += "dataId=" + encodeURIComponent("" + dataId) + "&";
    if (actionType === null)
      throw new Error("The parameter 'actionType' cannot be null.");
    else if (actionType !== undefined)
      url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetVehicleActions(_response);
    });
  }

  protected processGetVehicleActions(
    response: Response
  ): Promise<VehicleDTOActionHistoryDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 =
          VehicleDTOActionHistoryDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 =
          VehicleDTOActionHistoryDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<VehicleDTOActionHistoryDTOListResponseDTO>(
      null as any
    );
  }

  /**
   * Получение истории действий, связанных с функциями
   * @param userId (optional) Идентификатор пользователя
   * @param dataId (optional) Id данных
   * @param actionType (optional) Тип действия
   * @return Возвращает сообщение об успехе, если удалось получить список действий и сам список
   */
  getFunctionActions(
    userId: string | undefined,
    dataId: string | undefined,
    actionType: ActionType | undefined
  ): Promise<FunctionDTOActionHistoryDTOListResponseDTO> {
    let url_ = this.baseUrl + "/admin/action-history/get-function-actions?";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (dataId === null)
      throw new Error("The parameter 'dataId' cannot be null.");
    else if (dataId !== undefined)
      url_ += "dataId=" + encodeURIComponent("" + dataId) + "&";
    if (actionType === null)
      throw new Error("The parameter 'actionType' cannot be null.");
    else if (actionType !== undefined)
      url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFunctionActions(_response);
    });
  }

  protected processGetFunctionActions(
    response: Response
  ): Promise<FunctionDTOActionHistoryDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 =
          FunctionDTOActionHistoryDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 =
          FunctionDTOActionHistoryDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionDTOActionHistoryDTOListResponseDTO>(
      null as any
    );
  }

  /**
   * Получение истории действий, связанных с группами функций
   * @param userId (optional) Идентификатор пользователя
   * @param dataId (optional) Id данных
   * @param actionType (optional) Тип действия
   * @return Возвращает сообщение об успехе, если удалось получить список действий и сам список
   */
  getFunctionGroupActions(
    userId: string | undefined,
    dataId: string | undefined,
    actionType: ActionType | undefined
  ): Promise<FunctionGroupActionHistoryDTOListResponseDTO> {
    let url_ =
      this.baseUrl + "/admin/action-history/get-function-group-actions?";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (dataId === null)
      throw new Error("The parameter 'dataId' cannot be null.");
    else if (dataId !== undefined)
      url_ += "dataId=" + encodeURIComponent("" + dataId) + "&";
    if (actionType === null)
      throw new Error("The parameter 'actionType' cannot be null.");
    else if (actionType !== undefined)
      url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFunctionGroupActions(_response);
    });
  }

  protected processGetFunctionGroupActions(
    response: Response
  ): Promise<FunctionGroupActionHistoryDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 =
          FunctionGroupActionHistoryDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 =
          FunctionGroupActionHistoryDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionGroupActionHistoryDTOListResponseDTO>(
      null as any
    );
  }

  /**
   * Получение истории действий, связанных с его учетной записью (аккаунтом)
   * @param userId (optional) Идентификатор пользователя
   * @param dataId (optional) Id данных
   * @param actionType (optional) Тип действия
   * @return Возвращает сообщение об успехе, если удалось получить список действий и сам список
   */
  getAccountActions(
    userId: string | undefined,
    dataId: string | undefined,
    actionType: ActionType | undefined
  ): Promise<UserDTOActionHistoryDTOListResponseDTO> {
    let url_ = this.baseUrl + "/admin/action-history/get-account-actions?";
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (dataId === null)
      throw new Error("The parameter 'dataId' cannot be null.");
    else if (dataId !== undefined)
      url_ += "dataId=" + encodeURIComponent("" + dataId) + "&";
    if (actionType === null)
      throw new Error("The parameter 'actionType' cannot be null.");
    else if (actionType !== undefined)
      url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAccountActions(_response);
    });
  }

  protected processGetAccountActions(
    response: Response
  ): Promise<UserDTOActionHistoryDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 =
          UserDTOActionHistoryDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 =
          UserDTOActionHistoryDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserDTOActionHistoryDTOListResponseDTO>(null as any);
  }

  /**
   * Получить список компаний
   * @return Возвращает сообщение об успехе, если удалось получить список компаний
   */
  getCompanies(): Promise<CompanyDTOListResponseDTO> {
    let url_ = this.baseUrl + "/admin/company/get-companies";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCompanies(_response);
    });
  }

  protected processGetCompanies(
    response: Response
  ): Promise<CompanyDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CompanyDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CompanyDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0439",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CompanyDTOListResponseDTO>(null as any);
  }

  /**
   * Создать компанию
   * @param body (optional) Объект с данными о компании
   * @return Возвращает сообщение об успехе, если удалось создать компанию
   */
  createCompany(
    body: CompanyDTO | undefined
  ): Promise<CompanyDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/company/create-company";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateCompany(_response);
    });
  }

  protected processCreateCompany(
    response: Response
  ): Promise<CompanyDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CompanyDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CompanyDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0441\u043e\u0437\u0434\u0430\u0442\u044c \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u044e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CompanyDTOObjectResponseDTO>(null as any);
  }

  /**
   * Изменить данные компании
   * @param body (optional) Объект с данными о компании
   * @return Возвращает сообщение об успехе, если удалось изменить компанию
   */
  updateCompany(
    body: CompanyDTO | undefined
  ): Promise<CompanyDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/company/update-company";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateCompany(_response);
    });
  }

  protected processUpdateCompany(
    response: Response
  ): Promise<CompanyDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CompanyDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CompanyDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u044e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CompanyDTOObjectResponseDTO>(null as any);
  }

  /**
   * Удалить компанию
   * @param companyId Id компании
   * @return Возвращает сообщение об успехе, если удалось удалить компанию
   */
  deleteCompany(companyId: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/company/delete-company?";
    if (companyId === undefined || companyId === null)
      throw new Error(
        "The parameter 'companyId' must be defined and cannot be null."
      );
    else url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteCompany(_response);
    });
  }

  protected processDeleteCompany(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u044e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Множественное удаление компаний
   * @param body (optional) Массив с идентификаторами компаний
   * @return Возвращает сообщение об успехе, если удалось удалить компании
   */
  multipleDeleteCompanies(body: string[] | undefined): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/company/multiple-delete-companies";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMultipleDeleteCompanies(_response);
    });
  }

  protected processMultipleDeleteCompanies(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Поиск компании по токену
   * @param token Токен компании
   * @return Возвращает сообщение об успехе, если удалось найти компанию
   */
  findCompanyByToken(token: string): Promise<CompanyObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/company/find-company-by-token?";
    if (token === undefined || token === null)
      throw new Error(
        "The parameter 'token' must be defined and cannot be null."
      );
    else url_ += "token=" + encodeURIComponent("" + token) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processFindCompanyByToken(_response);
    });
  }

  protected processFindCompanyByToken(
    response: Response
  ): Promise<CompanyObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CompanyObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CompanyObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043d\u0430\u0439\u0442\u0438 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u044e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CompanyObjectResponseDTO>(null as any);
  }

  /**
   * Отозвать токен компании
   * @param companyId Id компании
   * @return Возвращает сообщение об успехе, если удалось отозвать токен компании
   */
  revokeCompanyToken(companyId: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/company/revoke-company-token?";
    if (companyId === undefined || companyId === null)
      throw new Error(
        "The parameter 'companyId' must be defined and cannot be null."
      );
    else url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRevokeCompanyToken(_response);
    });
  }

  protected processRevokeCompanyToken(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u043e\u0442\u043e\u0437\u0432\u0430\u0442\u044c \u0442\u043e\u043a\u0435\u043d \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Обновить (изменить) токен компании
   * @param companyId Id компании
   * @return Возвращает сообщение об успехе, если удалось обновить (изменить) токен компании
   */
  refreshCompanyToken(companyId: string): Promise<CompanyDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/company/refresh-company-token?";
    if (companyId === undefined || companyId === null)
      throw new Error(
        "The parameter 'companyId' must be defined and cannot be null."
      );
    else url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRefreshCompanyToken(_response);
    });
  }

  protected processRefreshCompanyToken(
    response: Response
  ): Promise<CompanyDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CompanyDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CompanyDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0431\u043d\u043e\u0432\u0438\u0442\u044c (\u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c) \u0442\u043e\u043a\u0435\u043d \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CompanyDTOObjectResponseDTO>(null as any);
  }

  /**
   * Аутентификация для брокера компании
   * @param body (optional) Модель с данными для подключения к брокеру
   * @return Возвращает сообщение об успешной аутентификации
   */
  loginCompanyBroker(body: LoginBrokerDTO | undefined): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/company/login-company-broker";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processLoginCompanyBroker(_response);
    });
  }

  protected processLoginCompanyBroker(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ResponseDTO.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0443\u0442\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Получить список прошивок
   * @return Возвращает сообщение об успехе, если удалось получить список прошивок
   */
  getFirmwares(): Promise<FirmwareListResponseDTO> {
    let url_ = this.baseUrl + "/admin/firmware/get-firmwares";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFirmwares(_response);
    });
  }

  protected processGetFirmwares(
    response: Response
  ): Promise<FirmwareListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FirmwareListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FirmwareListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u043f\u0440\u043e\u0448\u0438\u0432\u043e\u043a",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FirmwareListResponseDTO>(null as any);
  }

  /**
   * Получить список компаний, которые имеют доступ к прошивке
   * @param firmwareId Идентификатор прошивки
   * @return Возвращает сообщение об успехе, если удалось получить список компаний
   */
  getFirmwareCompanies(firmwareId: string): Promise<CompanyDTOListResponseDTO> {
    let url_ = this.baseUrl + "/admin/firmware/get-firmware-companies?";
    if (firmwareId === undefined || firmwareId === null)
      throw new Error(
        "The parameter 'firmwareId' must be defined and cannot be null."
      );
    else url_ += "firmwareId=" + encodeURIComponent("" + firmwareId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFirmwareCompanies(_response);
    });
  }

  protected processGetFirmwareCompanies(
    response: Response
  ): Promise<CompanyDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CompanyDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CompanyDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0439",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CompanyDTOListResponseDTO>(null as any);
  }

  /**
   * Загрузка файла прошивки на сервер
   * @param name (optional) Название прошивки
   * @param fileName (optional) Название файла
   * @param version (optional) Версия
   * @param file (optional) Файл
   * @return Возвращает сообщение об успехе, если удалось загрузить файл
   */
  uploadFirmware(
    name: string | undefined,
    fileName: string | undefined,
    version: string | undefined,
    file: FileParameter | undefined
  ): Promise<FirmwareObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/firmware/upload-firmware";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (name === null || name === undefined)
      throw new Error("The parameter 'name' cannot be null.");
    else content_.append("Name", name.toString());
    if (fileName === null || fileName === undefined)
      throw new Error("The parameter 'fileName' cannot be null.");
    else content_.append("FileName", fileName.toString());
    if (version === null || version === undefined)
      throw new Error("The parameter 'version' cannot be null.");
    else content_.append("Version", version.toString());
    if (file === null || file === undefined)
      throw new Error("The parameter 'file' cannot be null.");
    else
      content_.append(
        "File",
        file.data,
        file.fileName ? file.fileName : "File"
      );

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUploadFirmware(_response);
    });
  }

  protected processUploadFirmware(
    response: Response
  ): Promise<FirmwareObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FirmwareObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FirmwareObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c \u0444\u0430\u0439\u043b",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FirmwareObjectResponseDTO>(null as any);
  }

  /**
   * Скачивание файла прошивки с сервера
   * @param fileName (optional) Название файла
   * @return Возвращает сообщение об успехе, если удалось скачать файл
   */
  downloadFirmware(fileName: string | undefined): Promise<FileResponse> {
    let url_ = this.baseUrl + "/admin/firmware/download-firmware?";
    if (fileName === null)
      throw new Error("The parameter 'fileName' cannot be null.");
    else if (fileName !== undefined)
      url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDownloadFirmware(_response);
    });
  }

  protected processDownloadFirmware(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get("content-disposition")
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return response.blob().then((blob) => {
        return {
          fileName: fileName,
          data: blob,
          status: status,
          headers: _headers,
        };
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = DownloadFileDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0441\u043a\u0430\u0447\u0430\u0442\u044c \u0444\u0430\u0439\u043b",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  /**
   * Начать обновление ПО (для нескольких компаний)
   * @param body Объект с данными, необходимыми для начала обновления ПО
   * @return Возвращает сообщение об успехе, если удалось начать обновление ПО
   */
  startUpdateSession(
    body: StartUpdateSessionDTO
  ): Promise<StartUpdateSessionResultDTOListResponseDTO> {
    let url_ = this.baseUrl + "/admin/firmware/start-update-session";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processStartUpdateSession(_response);
    });
  }

  protected processStartUpdateSession(
    response: Response
  ): Promise<StartUpdateSessionResultDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 =
          StartUpdateSessionResultDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 =
          StartUpdateSessionResultDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043d\u0430\u0447\u0430\u0442\u044c \u043e\u0431\u043d\u043e\u0432\u043b\u0435\u043d\u0438\u0435 \u041f\u041e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StartUpdateSessionResultDTOListResponseDTO>(
      null as any
    );
  }

  /**
   * Начать обновление ПО (для компании пользователя)
   * @param body Объект с данными, необходимыми для начала обновления ПО
   * @return Возвращает сообщение об успехе, если удалось начать обновление ПО
   */
  startCompanyUpdateSession(
    body: StartCompanyUpdateSessionDTO
  ): Promise<StartUpdateSessionResultDTOListResponseDTO> {
    let url_ = this.baseUrl + "/admin/firmware/start-company-update-session";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processStartCompanyUpdateSession(_response);
    });
  }

  protected processStartCompanyUpdateSession(
    response: Response
  ): Promise<StartUpdateSessionResultDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 =
          StartUpdateSessionResultDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 =
          StartUpdateSessionResultDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043d\u0430\u0447\u0430\u0442\u044c \u043e\u0431\u043d\u043e\u0432\u043b\u0435\u043d\u0438\u0435 \u041f\u041e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StartUpdateSessionResultDTOListResponseDTO>(
      null as any
    );
  }

  /**
   * Получить данные (результаты) сессии
   * @param sessionId Id сессии
   * @param includeResults (optional) Получить результаты обновления для каждого транспортного средства?
   * @return Возвращает сообщение об успехе, если удалось получить данные (результаты) сессии обновления ПО
   */
  getSession(
    sessionId: string,
    includeResults: boolean | undefined
  ): Promise<UpdateSessionDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/firmware/get-session?";
    if (sessionId === undefined || sessionId === null)
      throw new Error(
        "The parameter 'sessionId' must be defined and cannot be null."
      );
    else url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
    if (includeResults === null)
      throw new Error("The parameter 'includeResults' cannot be null.");
    else if (includeResults !== undefined)
      url_ += "includeResults=" + encodeURIComponent("" + includeResults) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSession(_response);
    });
  }

  protected processGetSession(
    response: Response
  ): Promise<UpdateSessionDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UpdateSessionDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = UpdateSessionDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0434\u0430\u043d\u043d\u044b\u0435 (\u0440\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u044b) \u0441\u0435\u0441\u0441\u0438\u0438 \u043e\u0431\u043d\u043e\u0432\u043b\u0435\u043d\u0438\u044f \u041f\u041e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UpdateSessionDTOObjectResponseDTO>(null as any);
  }

  /**
   * Получить результаты обновления ПО (по Id сессии)
   * @param sessionId (optional) Идентификатор сессии
   * @return Возвращает сообщение об успехе, если удалось получить результаты обновления ПО
   */
  getUpdateResultsBySessionId(
    sessionId: string | undefined
  ): Promise<UpdateResultDTOListResponseDTO> {
    let url_ =
      this.baseUrl + "/admin/firmware/get-update-results-by-session-id?";
    if (sessionId === null)
      throw new Error("The parameter 'sessionId' cannot be null.");
    else if (sessionId !== undefined)
      url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUpdateResultsBySessionId(_response);
    });
  }

  protected processGetUpdateResultsBySessionId(
    response: Response
  ): Promise<UpdateResultDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UpdateResultDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = UpdateResultDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0440\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u044b \u043e\u0431\u043d\u043e\u0432\u043b\u0435\u043d\u0438\u044f \u041f\u041e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UpdateResultDTOListResponseDTO>(null as any);
  }

  /**
   * Получить результаты обновления ПО с сортировкой по дате (в промежутке) и названию (или UVI) транспортного средства
   * @param searchString (optional) Строка из поля поиска
   * @param firstDate (optional) Начальная дата
   * @param lastDate (optional) Конечная дата
   * @return Возвращает сообщение об успехе, если удалось получить результаты обновления ПО
   */
  getUpdateResults(
    searchString: string | undefined,
    firstDate: Date | undefined,
    lastDate: Date | undefined
  ): Promise<UpdateResultDTOListResponseDTO> {
    let url_ = this.baseUrl + "/admin/firmware/get-update-results?";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    if (firstDate === null)
      throw new Error("The parameter 'firstDate' cannot be null.");
    else if (firstDate !== undefined)
      url_ +=
        "firstDate=" +
        encodeURIComponent(firstDate ? "" + firstDate.toISOString() : "") +
        "&";
    if (lastDate === null)
      throw new Error("The parameter 'lastDate' cannot be null.");
    else if (lastDate !== undefined)
      url_ +=
        "lastDate=" +
        encodeURIComponent(lastDate ? "" + lastDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUpdateResults(_response);
    });
  }

  protected processGetUpdateResults(
    response: Response
  ): Promise<UpdateResultDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UpdateResultDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = UpdateResultDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0440\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u044b \u043e\u0431\u043d\u043e\u0432\u043b\u0435\u043d\u0438\u044f \u041f\u041e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "Forbidden",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UpdateResultDTOListResponseDTO>(null as any);
  }

  /**
   * Обновить статус сессии
   * @param sessionId Идентификатор сессии
   * @return Возвращает сообщение об успехе, если удалось обновить статус сессии
   */
  updateSessionStatus(
    sessionId: string
  ): Promise<UpdateSessionDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/firmware/update-session-status?";
    if (sessionId === undefined || sessionId === null)
      throw new Error(
        "The parameter 'sessionId' must be defined and cannot be null."
      );
    else url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateSessionStatus(_response);
    });
  }

  protected processUpdateSessionStatus(
    response: Response
  ): Promise<UpdateSessionDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UpdateSessionDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = UpdateSessionDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0431\u043d\u043e\u0432\u0438\u0442\u044c \u0441\u0442\u0430\u0442\u0443\u0441 \u0441\u0435\u0441\u0441\u0438\u0438",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UpdateSessionDTOObjectResponseDTO>(null as any);
  }

  /**
   * Предоставить компаниям доступ к прошивке
   * @param body (optional) Объект, содержащий идентификатор прошивки и идентификаторы компаний, которым необходимо предоставить доступ
   * @return Возвращает сообщение об успехе, если удалось предоставить компаниям доступ к прошивке
   */
  provideAccessToFirmware(
    body: ProvideAccessToFirmwareDTO | undefined
  ): Promise<FirmwareObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/firmware/provide-access-to-firmware";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProvideAccessToFirmware(_response);
    });
  }

  protected processProvideAccessToFirmware(
    response: Response
  ): Promise<FirmwareObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FirmwareObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FirmwareObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u0440\u0435\u0434\u043e\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u044f\u043c \u0434\u043e\u0441\u0442\u0443\u043f \u043a \u043f\u0440\u043e\u0448\u0438\u0432\u043a\u0435",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FirmwareObjectResponseDTO>(null as any);
  }

  /**
   * Удаление прошивки
   * @param firmwareId (optional) Идентификатор прошивки
   * @return Возвращает сообщение об успехе, если удалось удалить прошивку
   */
  deleteFirmware(firmwareId: string | undefined): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/firmware/delete-firmware?";
    if (firmwareId === null)
      throw new Error("The parameter 'firmwareId' cannot be null.");
    else if (firmwareId !== undefined)
      url_ += "FirmwareId=" + encodeURIComponent("" + firmwareId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteFirmware(_response);
    });
  }

  protected processDeleteFirmware(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u043f\u0440\u043e\u0448\u0438\u0432\u043a\u0443",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Множественное удаление прошивок
   * @param body (optional) Массив с идентификаторами прошивок
   * @return Возвращает сообщение об успехе, если удалось удалить прошивки
   */
  multipleDeleteFirmwares(body: string[] | undefined): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/firmware/multiple-delete-firmwares";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMultipleDeleteFirmwares(_response);
    });
  }

  protected processMultipleDeleteFirmwares(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u043f\u0440\u043e\u0448\u0438\u0432\u043a\u0438",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Получить текущую загруженную версию ПО модуля (по uvi)
   * @param uvi Уникальный идентификатор транспортного средства
   * @return Возвращает сообщение об успехе, если удалось получить версию ПО
   */
  getModuleFirmware(uvi: string): Promise<ModuleFirmwareDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/firmware/get-module-firmware?";
    if (uvi === undefined || uvi === null)
      throw new Error(
        "The parameter 'uvi' must be defined and cannot be null."
      );
    else url_ += "Uvi=" + encodeURIComponent("" + uvi) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetModuleFirmware(_response);
    });
  }

  protected processGetModuleFirmware(
    response: Response
  ): Promise<ModuleFirmwareDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ModuleFirmwareDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ModuleFirmwareDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0432\u0435\u0440\u0441\u0438\u044e \u041f\u041e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ModuleFirmwareDTOObjectResponseDTO.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ModuleFirmwareDTOObjectResponseDTO>(null as any);
  }

  /**
   * Получение списка пользователей
   * @return Возвращает сообщение об успехе, если удалось получить список пользователей
   */
  getUsers(): Promise<UserDTOListResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/get-users";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUsers(_response);
    });
  }

  protected processGetUsers(
    response: Response
  ): Promise<UserDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UserDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = UserDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserDTOListResponseDTO>(null as any);
  }

  /**
   * Получение ролей пользователя
   * @param userId Идентификатор пользователя
   * @return Возвращает сообщение об успехе, если удалось получить список ролей и сам список
   */
  getUserRoles(userId: string): Promise<RoleDTOListResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/get-user-roles?";
    if (userId === undefined || userId === null)
      throw new Error(
        "The parameter 'userId' must be defined and cannot be null."
      );
    else url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUserRoles(_response);
    });
  }

  protected processGetUserRoles(
    response: Response
  ): Promise<RoleDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RoleDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = RoleDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u0440\u043e\u043b\u0435\u0439 \u0438 \u0441\u0430\u043c \u0441\u043f\u0438\u0441\u043e\u043a",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<RoleDTOListResponseDTO>(null as any);
  }

  /**
   * Создание пользователя
   * @param body (optional) Объект с данными пользователя
   * @return Возвращает сообщение об успехе, если удалось создать пользователя
   */
  createUser(body: UserDTO | undefined): Promise<UserDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/create-user";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateUser(_response);
    });
  }

  protected processCreateUser(
    response: Response
  ): Promise<UserDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UserDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = UserDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0441\u043e\u0437\u0434\u0430\u0442\u044c \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserDTOObjectResponseDTO>(null as any);
  }

  /**
   * Изменение данных пользователя
   * @param body (optional) Объект с данными пользователя
   * @return Возвращает сообщение об успехе, если удалось изменить данные пользователя
   */
  updateUser(body: UserDTO | undefined): Promise<UserDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/update-user";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateUser(_response);
    });
  }

  protected processUpdateUser(
    response: Response
  ): Promise<UserDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UserDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = UserDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0434\u0430\u043d\u043d\u044b\u0435 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserDTOObjectResponseDTO>(null as any);
  }

  /**
   * Удаление пользователя
   * @param id Идентификатор пользователя
   * @return Возвращает сообщение об успехе, если удалось удалить пользователя
   */
  deleteUser(id: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/delete-user?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteUser(_response);
    });
  }

  protected processDeleteUser(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Множественное удаление пользователей
   * @param body (optional) Массив с идентификаторами пользователей
   * @return Возвращает сообщение об успехе, если удалось удалить пользователей
   */
  multipleDeleteUsers(body: string[] | undefined): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/multiple-delete-users";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processMultipleDeleteUsers(_response);
    });
  }

  protected processMultipleDeleteUsers(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u0435\u0439",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Отозвать токен
   * @param userId Id пользователя
   * @return Возвращает сообщение об успешном отзыве токена
   */
  revokeToken(userId: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/revoke-token?";
    if (userId === undefined || userId === null)
      throw new Error(
        "The parameter 'userId' must be defined and cannot be null."
      );
    else url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRevokeToken(_response);
    });
  }

  protected processRevokeToken(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043e\u0437\u0432\u0430\u0442\u044c \u0442\u043e\u043a\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Отозвать все токены
   * @return Возвращает сообщение об успешном отзыве токенов
   */
  revokeAllTokens(): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/revoke-all-tokens";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRevokeAllTokens(_response);
    });
  }

  protected processRevokeAllTokens(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043e\u0437\u0432\u0430\u0442\u044c \u0442\u043e\u043a\u0435\u043d\u044b",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Добавление роли для пользователя
   * @param roleName Имя роли
   * @param userId Идентификатор пользователя
   * @return Возвращает сообщение об успехе, если удалось добавить роль
   */
  addUserToRole(roleName: string, userId: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/add-user-to-role?";
    if (roleName === undefined || roleName === null)
      throw new Error(
        "The parameter 'roleName' must be defined and cannot be null."
      );
    else url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
    if (userId === undefined || userId === null)
      throw new Error(
        "The parameter 'userId' must be defined and cannot be null."
      );
    else url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddUserToRole(_response);
    });
  }

  protected processAddUserToRole(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0434\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0440\u043e\u043b\u044c",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Удаление роли у пользователя
   * @param roleName Имя роли
   * @param userId Идентификатор пользователя
   * @return Возвращает сообщение об успехе, если удалось удалить роль
   */
  removeUserFromRole(roleName: string, userId: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/remove-user-from-role?";
    if (roleName === undefined || roleName === null)
      throw new Error(
        "The parameter 'roleName' must be defined and cannot be null."
      );
    else url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
    if (userId === undefined || userId === null)
      throw new Error(
        "The parameter 'userId' must be defined and cannot be null."
      );
    else url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveUserFromRole(_response);
    });
  }

  protected processRemoveUserFromRole(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u0440\u043e\u043b\u044c",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Изменение роли пользователя
   * @param oldRoleName Имя старой роли
   * @param newRoleName Имя новой роли
   * @param userId Идентификатор пользователя
   * @return Возвращает сообщение об успехе, если удалось изменить роль
   */
  changeUserRole(
    oldRoleName: string,
    newRoleName: string,
    userId: string
  ): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/change-user-role?";
    if (oldRoleName === undefined || oldRoleName === null)
      throw new Error(
        "The parameter 'oldRoleName' must be defined and cannot be null."
      );
    else url_ += "oldRoleName=" + encodeURIComponent("" + oldRoleName) + "&";
    if (newRoleName === undefined || newRoleName === null)
      throw new Error(
        "The parameter 'newRoleName' must be defined and cannot be null."
      );
    else url_ += "newRoleName=" + encodeURIComponent("" + newRoleName) + "&";
    if (userId === undefined || userId === null)
      throw new Error(
        "The parameter 'userId' must be defined and cannot be null."
      );
    else url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processChangeUserRole(_response);
    });
  }

  protected processChangeUserRole(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0440\u043e\u043b\u044c",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Изменение электронной почты пользователя
   * @param userId Идентификатор пользователя
   * @param newEmail Новый адрес электронной почты
   * @param emailConfirmed (optional) Почта подтверждена? (Если false, то пользователю придет письмо с подтверждением на новую почту)
   * @return Возвращает сообщение об успехе, если удалось изменить почту
   */
  changeUserEmail(
    userId: string,
    newEmail: string,
    emailConfirmed: boolean | undefined
  ): Promise<UserDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/change-user-email?";
    if (userId === undefined || userId === null)
      throw new Error(
        "The parameter 'userId' must be defined and cannot be null."
      );
    else url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (newEmail === undefined || newEmail === null)
      throw new Error(
        "The parameter 'newEmail' must be defined and cannot be null."
      );
    else url_ += "newEmail=" + encodeURIComponent("" + newEmail) + "&";
    if (emailConfirmed === null)
      throw new Error("The parameter 'emailConfirmed' cannot be null.");
    else if (emailConfirmed !== undefined)
      url_ += "emailConfirmed=" + encodeURIComponent("" + emailConfirmed) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processChangeUserEmail(_response);
    });
  }

  protected processChangeUserEmail(
    response: Response
  ): Promise<UserDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UserDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = UserDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u043f\u043e\u0447\u0442\u0443",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserDTOObjectResponseDTO>(null as any);
  }

  /**
   * Изменение пароля пользователя
   * @param userId Идентификатор пользователя
   * @param newPassword Новый пароль
   * @return Возвращает сообщение об успехе, если удалось изменить пароль
   */
  changeUserPassword(
    userId: string,
    newPassword: string
  ): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/change-user-password?";
    if (userId === undefined || userId === null)
      throw new Error(
        "The parameter 'userId' must be defined and cannot be null."
      );
    else url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (newPassword === undefined || newPassword === null)
      throw new Error(
        "The parameter 'newPassword' must be defined and cannot be null."
      );
    else url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processChangeUserPassword(_response);
    });
  }

  protected processChangeUserPassword(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u043f\u0430\u0440\u043e\u043b\u044c",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Отправить письмо пользователю
   * @param userEmail Почта пользователя
   * @param subject Тема письма
   * @param mailText Текст письма
   * @return Возвращает сообщение об успехе, если удалось отправить письмо
   */
  sendEmailToUser(
    userEmail: string,
    subject: string,
    mailText: string
  ): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/user/send-email-to-user?";
    if (userEmail === undefined || userEmail === null)
      throw new Error(
        "The parameter 'userEmail' must be defined and cannot be null."
      );
    else url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
    if (subject === undefined || subject === null)
      throw new Error(
        "The parameter 'subject' must be defined and cannot be null."
      );
    else url_ += "subject=" + encodeURIComponent("" + subject) + "&";
    if (mailText === undefined || mailText === null)
      throw new Error(
        "The parameter 'mailText' must be defined and cannot be null."
      );
    else url_ += "mailText=" + encodeURIComponent("" + mailText) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSendEmailToUser(_response);
    });
  }

  protected processSendEmailToUser(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043f\u0438\u0441\u044c\u043c\u043e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Получение всех ролей
   * @return Возвращает сообщение об успехе, если удалось получить список ролей и сам список
   */
  getRoles(): Promise<RoleDTOListResponseDTO> {
    let url_ = this.baseUrl + "/admin/user-role/get-roles";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetRoles(_response);
    });
  }

  protected processGetRoles(
    response: Response
  ): Promise<RoleDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RoleDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = RoleDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<RoleDTOListResponseDTO>(null as any);
  }

  /**
   * Создание роли
   * @param roleName (optional) Имя роли
   * @return Возвращает сообщение об успехе, если удалось создать роль
   */
  createRole(roleName: string | undefined): Promise<RoleDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/admin/user-role/create-role?";
    if (roleName === null)
      throw new Error("The parameter 'roleName' cannot be null.");
    else if (roleName !== undefined)
      url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateRole(_response);
    });
  }

  protected processCreateRole(
    response: Response
  ): Promise<RoleDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RoleDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = RoleDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<RoleDTOObjectResponseDTO>(null as any);
  }

  /**
   * Изменение роли
   * @param body (optional) Объект роли
   * @return Возвращает сообщение об успехе, если удалось изменить роль
   */
  updateRole(body: RoleDTO | undefined): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/user-role/update-role";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateRole(_response);
    });
  }

  protected processUpdateRole(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Удаление роли
   * @param roleId (optional) Идентификатор роли
   * @return Возвращает сообщение об успехе, если удалось удалить роль
   */
  deleteRole(roleId: string | undefined): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/admin/user-role/delete-role?";
    if (roleId === null)
      throw new Error("The parameter 'roleId' cannot be null.");
    else if (roleId !== undefined)
      url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteRole(_response);
    });
  }

  protected processDeleteRole(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Получить все can-идентификаторы (для всех транспортных средств)
   * @return Возвращает сообщение об успехе, если удалось получить список can-идентификаторов
   */
  getAllCanIdentifiers(): Promise<CanIdentifierDTOListResponseDTO> {
    let url_ =
      this.baseUrl + "/services/can-identifier/get-all-can-identifiers";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllCanIdentifiers(_response);
    });
  }

  protected processGetAllCanIdentifiers(
    response: Response
  ): Promise<CanIdentifierDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CanIdentifierDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CanIdentifierDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a can-\u0438\u0434\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u043e\u0440\u043e\u0432",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CanIdentifierDTOListResponseDTO>(null as any);
  }

  /**
   * Получить все can-идентификаторы для выбранного транспортного средства (по UVI)
   * @param uVI Уникальный идентификатор транспортного средства
   * @param protocol (optional) Протокол
   * @param includeDiagnostic (optional) Включить в список идентификатор для диагностики или нет
   * @return Возвращает сообщение об успехе, если удалось получить список can-идентификаторов
   */
  getCanIdentifiers(
    uVI: string,
    protocol: Protocol | undefined,
    includeDiagnostic: boolean | undefined
  ): Promise<CanIdentifierDTOListResponseDTO> {
    let url_ = this.baseUrl + "/services/can-identifier/get-can-identifiers?";
    if (uVI === undefined || uVI === null)
      throw new Error(
        "The parameter 'uVI' must be defined and cannot be null."
      );
    else url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    if (protocol === null)
      throw new Error("The parameter 'protocol' cannot be null.");
    else if (protocol !== undefined)
      url_ += "protocol=" + encodeURIComponent("" + protocol) + "&";
    if (includeDiagnostic === null)
      throw new Error("The parameter 'includeDiagnostic' cannot be null.");
    else if (includeDiagnostic !== undefined)
      url_ +=
        "includeDiagnostic=" + encodeURIComponent("" + includeDiagnostic) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCanIdentifiers(_response);
    });
  }

  protected processGetCanIdentifiers(
    response: Response
  ): Promise<CanIdentifierDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CanIdentifierDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CanIdentifierDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a can-\u0438\u0434\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u043e\u0440\u043e\u0432",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CanIdentifierDTOListResponseDTO>(null as any);
  }

  /**
   * Получить последние N (count) can-сообщений (по can id) за указанный период (period)
   * @param uVI Уникальный идентификатор транспортного средства
   * @param canId Can Id
   * @param period (optional) Период (в секундах)
   * @param count (optional) Количество сообщений
   * @return Возвращает сообщение об успехе, если удалось получить список can-сообщений
   */
  getCanMessages(
    uVI: string,
    canId: string,
    period: number | undefined,
    count: number | undefined
  ): Promise<CanMessageDTOListResponseDTO> {
    let url_ = this.baseUrl + "/services/can-identifier/get-can-messages?";
    if (uVI === undefined || uVI === null)
      throw new Error(
        "The parameter 'uVI' must be defined and cannot be null."
      );
    else url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    if (canId === undefined || canId === null)
      throw new Error(
        "The parameter 'canId' must be defined and cannot be null."
      );
    else url_ += "canId=" + encodeURIComponent("" + canId) + "&";
    if (period === null)
      throw new Error("The parameter 'period' cannot be null.");
    else if (period !== undefined)
      url_ += "period=" + encodeURIComponent("" + period) + "&";
    if (count === null)
      throw new Error("The parameter 'count' cannot be null.");
    else if (count !== undefined)
      url_ += "count=" + encodeURIComponent("" + count) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCanMessages(_response);
    });
  }

  protected processGetCanMessages(
    response: Response
  ): Promise<CanMessageDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CanMessageDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CanMessageDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a can-\u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0439",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CanMessageDTOListResponseDTO>(null as any);
  }

  /**
   * Обновить список can-идентификаторов (добавить, удалить, изменить)
   * @param uVI Уникальный идентификатор транспортного средства
   * @param body (optional) Список can-идентификаторов
   * @return Возвращает сообщение об успехе, если удалось обновить список can-идентификаторов
   */
  updateCanIdentifiers(
    uVI: string,
    body: CanIdentifierDTO[] | undefined
  ): Promise<CanIdentifierDTOListResponseDTO> {
    let url_ =
      this.baseUrl + "/services/can-identifier/update-can-identifiers?";
    if (uVI === undefined || uVI === null)
      throw new Error(
        "The parameter 'uVI' must be defined and cannot be null."
      );
    else url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateCanIdentifiers(_response);
    });
  }

  protected processUpdateCanIdentifiers(
    response: Response
  ): Promise<CanIdentifierDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CanIdentifierDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CanIdentifierDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0431\u043d\u043e\u0432\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a can-\u0438\u0434\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u043e\u0440\u043e\u0432",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CanIdentifierDTOListResponseDTO>(null as any);
  }

  /**
   * Получение списка функций транспортного средства (по UVI)
   * @param uVI Уникальный идентификатор транспортного средства
   * @param date (optional) Дата и время
   * @return Возвращает сообщение об успехе, если удалось получить список функций (и сам список)
   */
  getFunctions(
    uVI: string,
    date: Date | undefined
  ): Promise<FunctionDTOListResponseDTO> {
    let url_ = this.baseUrl + "/services/function/get-functions?";
    if (uVI === undefined || uVI === null)
      throw new Error(
        "The parameter 'uVI' must be defined and cannot be null."
      );
    else url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    if (date === null) throw new Error("The parameter 'date' cannot be null.");
    else if (date !== undefined)
      url_ +=
        "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFunctions(_response);
    });
  }

  protected processGetFunctions(
    response: Response
  ): Promise<FunctionDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FunctionDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FunctionDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u0444\u0443\u043d\u043a\u0446\u0438\u0439",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionDTOListResponseDTO>(null as any);
  }

  /**
   * Получение всех функций
   * @return Возвращает сообщение об успехе, если удалось получить список функций (и сам список)
   */
  getAllFunctions(): Promise<FunctionDTOListResponseDTO> {
    let url_ = this.baseUrl + "/services/function/get-all-functions";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllFunctions(_response);
    });
  }

  protected processGetAllFunctions(
    response: Response
  ): Promise<FunctionDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FunctionDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FunctionDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u0444\u0443\u043d\u043a\u0446\u0438\u0439",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionDTOListResponseDTO>(null as any);
  }

  /**
   * Получение функции по названию
   * @param name Название функции
   * @return Возвращает сообщение об успехе, если удалось найти функцию
   */
  getFunctionByName(name: string): Promise<FunctionDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/function/get-function-by-name?";
    if (name === undefined || name === null)
      throw new Error(
        "The parameter 'name' must be defined and cannot be null."
      );
    else url_ += "name=" + encodeURIComponent("" + name) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFunctionByName(_response);
    });
  }

  protected processGetFunctionByName(
    response: Response
  ): Promise<FunctionDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FunctionDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FunctionDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043d\u0430\u0439\u0442\u0438 \u0444\u0443\u043d\u043a\u0446\u0438\u044e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionDTOObjectResponseDTO>(null as any);
  }

  /**
   * Получение функции по Id
   * @param id Id функции
   * @return Возвращает сообщение об успехе, если удалось найти функцию
   */
  getFunctionById(id: string): Promise<FunctionDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/function/get-function-by-id?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFunctionById(_response);
    });
  }

  protected processGetFunctionById(
    response: Response
  ): Promise<FunctionDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FunctionDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FunctionDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043d\u0430\u0439\u0442\u0438 \u0444\u0443\u043d\u043a\u0446\u0438\u044e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionDTOObjectResponseDTO>(null as any);
  }

  /**
   * Создание функции
   * @param body (optional) Модель с данными функции
   * @return Возвращает сообщение об успехе, если удалось создать новую функцию
   */
  createFunction(
    body: FunctionDTO | undefined
  ): Promise<FunctionDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/function/create-function";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateFunction(_response);
    });
  }

  protected processCreateFunction(
    response: Response
  ): Promise<FunctionDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FunctionDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FunctionDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionDTOObjectResponseDTO>(null as any);
  }

  /**
   * Редактирование функции
   * @param body (optional) Модель с данными функции
   * @return Возвращает сообщение об успехе, если удалось изменить функцию
   */
  updateFunction(
    body: FunctionDTO | undefined
  ): Promise<FunctionDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/function/update-function";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateFunction(_response);
    });
  }

  protected processUpdateFunction(
    response: Response
  ): Promise<FunctionDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FunctionDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FunctionDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionDTOObjectResponseDTO>(null as any);
  }

  /**
   * Удаление функции
   * @param id Id функции
   * @return Возвращает сообщение об успехе, если удалось удалить функцию
   */
  deleteFunction(id: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/services/function/delete-function?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteFunction(_response);
    });
  }

  protected processDeleteFunction(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Получение списка статусов
   * @return Возвращает сообщение об успехе, если удалось получить список статусов (и сам список)
   */
  getFunctionStatuses(): Promise<FunctionStatusListResponseDTO> {
    let url_ = this.baseUrl + "/services/function/get-function-statuses";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFunctionStatuses(_response);
    });
  }

  protected processGetFunctionStatuses(
    response: Response
  ): Promise<FunctionStatusListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FunctionStatusListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FunctionStatusListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u0441\u0442\u0430\u0442\u0443\u0441\u043e\u0432",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionStatusListResponseDTO>(null as any);
  }

  /**
   * Получить историю функции
   * @param id Id функции
   * @param period (optional) Период (в секундах)
   * @return Возвращает сообщение об успехе, если удалось получить историю функции
   */
  getFunctionHistory(
    id: string,
    period: number | undefined
  ): Promise<FunctionHistoryDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/function/get-function-history?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += "Id=" + encodeURIComponent("" + id) + "&";
    if (period === null)
      throw new Error("The parameter 'period' cannot be null.");
    else if (period !== undefined)
      url_ += "period=" + encodeURIComponent("" + period) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFunctionHistory(_response);
    });
  }

  protected processGetFunctionHistory(
    response: Response
  ): Promise<FunctionHistoryDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FunctionHistoryDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FunctionHistoryDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0438\u0441\u0442\u043e\u0440\u0438\u044e \u0444\u0443\u043d\u043a\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionHistoryDTOObjectResponseDTO>(null as any);
  }

  /**
   * Получение списка с группами функций
   * @return Возвращает сообщение об успехе, если удалось получить список с группами (и сам список)
   */
  getFunctionGroups(): Promise<FunctionGroupListResponseDTO> {
    let url_ = this.baseUrl + "/services/function-group/get-function-groups";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFunctionGroups(_response);
    });
  }

  protected processGetFunctionGroups(
    response: Response
  ): Promise<FunctionGroupListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FunctionGroupListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FunctionGroupListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u0441 \u0433\u0440\u0443\u043f\u043f\u0430\u043c\u0438",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionGroupListResponseDTO>(null as any);
  }

  /**
   * Создание группы для функций
   * @param groupName Название группы
   * @return Возвращает сообщение об успехе, если удалось создать группу
   */
  createFunctionGroup(
    groupName: string
  ): Promise<FunctionGroupObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/function-group/create-function-group?";
    if (groupName === undefined || groupName === null)
      throw new Error(
        "The parameter 'groupName' must be defined and cannot be null."
      );
    else url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateFunctionGroup(_response);
    });
  }

  protected processCreateFunctionGroup(
    response: Response
  ): Promise<FunctionGroupObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FunctionGroupObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FunctionGroupObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0441\u043e\u0437\u0434\u0430\u0442\u044c \u0433\u0440\u0443\u043f\u043f\u0443",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionGroupObjectResponseDTO>(null as any);
  }

  /**
   * Редактирование группы
   * @param body (optional) Объект с данными группы
   * @return Возвращает сообщение об успехе, если изменить создать группу
   */
  updateFunctionGroup(
    body: FunctionGroup | undefined
  ): Promise<FunctionGroupObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/function-group/update-function-group";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateFunctionGroup(_response);
    });
  }

  protected processUpdateFunctionGroup(
    response: Response
  ): Promise<FunctionGroupObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = FunctionGroupObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = FunctionGroupObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0433\u0440\u0443\u043f\u043f\u0443",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FunctionGroupObjectResponseDTO>(null as any);
  }

  /**
   * Удаление группы
   * @param id Id группы
   * @return Возвращает сообщение об успехе, если удалось удалить группу
   */
  deleteFunctionGroup(id: number): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/services/function-group/delete-function-group?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteFunctionGroup(_response);
    });
  }

  protected processDeleteFunctionGroup(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0443\u0434\u0430\u043b\u0438\u0442\u044c \u0433\u0440\u0443\u043f\u043f\u0443",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Получить все параметры
   * @return Возвращает сообщение об успехе, если удалось получить список параметров
   */
  getAllJ1939Parameters(): Promise<J1939ParametersDTOListResponseDTO> {
    let url_ = this.baseUrl + "/services/J1939/get-all-j1939-parameters";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllJ1939Parameters(_response);
    });
  }

  protected processGetAllJ1939Parameters(
    response: Response
  ): Promise<J1939ParametersDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = J1939ParametersDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = J1939ParametersDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u043f\u0430\u0440\u0430\u043c\u0435\u0442\u0440\u043e\u0432",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<J1939ParametersDTOListResponseDTO>(null as any);
  }

  /**
   * Получить параметры по PGN и SPN
   * @param pGN (optional) PGN
   * @param sPN (optional) SPN
   * @return Возвращает сообщение об успехе, если удалось получить параметры
   */
  getJ1939Parameters(
    pGN: number | undefined,
    sPN: number | undefined
  ): Promise<J1939ParametersDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/J1939/get-j1939-parameters?";
    if (pGN === null) throw new Error("The parameter 'pGN' cannot be null.");
    else if (pGN !== undefined)
      url_ += "PGN=" + encodeURIComponent("" + pGN) + "&";
    if (sPN === null) throw new Error("The parameter 'sPN' cannot be null.");
    else if (sPN !== undefined)
      url_ += "SPN=" + encodeURIComponent("" + sPN) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetJ1939Parameters(_response);
    });
  }

  protected processGetJ1939Parameters(
    response: Response
  ): Promise<J1939ParametersDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = J1939ParametersDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = J1939ParametersDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u043f\u0430\u0440\u0430\u043c\u0435\u0442\u0440\u044b",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<J1939ParametersDTOObjectResponseDTO>(null as any);
  }

  /**
   * Изменить список параметров
   * @param body (optional) Список параметров
   * @return Возвращает сообщение об успехе, если удалось изменить список параметров
   */
  updateJ1939Parameters(
    body: J1939ParametersDTO[] | undefined
  ): Promise<J1939ParametersDTOListResponseDTO> {
    let url_ = this.baseUrl + "/services/J1939/update-j1939-parameters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateJ1939Parameters(_response);
    });
  }

  protected processUpdateJ1939Parameters(
    response: Response
  ): Promise<J1939ParametersDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = J1939ParametersDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = J1939ParametersDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u043f\u0430\u0440\u0430\u043c\u0435\u0442\u0440\u043e\u0432",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<J1939ParametersDTOListResponseDTO>(null as any);
  }

  /**
   * Получить список модулей компании
   * @param companyId (optional) Id компании
   * @return Возвращает сообщение об успехе, если удалось получить список модулей
   */
  getModules(companyId: string | undefined): Promise<ModuleDTOListResponseDTO> {
    let url_ = this.baseUrl + "/services/module/get-modules?";
    if (companyId === null)
      throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined)
      url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetModules(_response);
    });
  }

  protected processGetModules(
    response: Response
  ): Promise<ModuleDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ModuleDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ModuleDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u043c\u043e\u0434\u0443\u043b\u0435\u0439",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ModuleDTOListResponseDTO>(null as any);
  }

  /**
   * Найти модуль по UVI
   * @param uVI Уникальный идентификатор транспортного средства
   * @return Возвращает сообщение об успехе, если удалось найти модуль (и объект с данными найденного модуля)
   */
  getModule(uVI: string): Promise<ModuleDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/module/get-module?";
    if (uVI === undefined || uVI === null)
      throw new Error(
        "The parameter 'uVI' must be defined and cannot be null."
      );
    else url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetModule(_response);
    });
  }

  protected processGetModule(
    response: Response
  ): Promise<ModuleDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ModuleDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ModuleDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043d\u0430\u0439\u0442\u0438 \u043c\u043e\u0434\u0443\u043b\u044c",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ModuleDTOObjectResponseDTO>(null as any);
  }

  /**
   * Создать модуль
   * @param body (optional) Объект с данными модуля
   * @return Возвращает сообщение об успехе, если удалось создать модуль
   */
  createModule(
    body: ModuleDTO | undefined
  ): Promise<ModuleDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/module/create-module";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateModule(_response);
    });
  }

  protected processCreateModule(
    response: Response
  ): Promise<ModuleDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ModuleDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ModuleDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0441\u043e\u0437\u0434\u0430\u0442\u044c \u043c\u043e\u0434\u0443\u043b\u044c",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ModuleDTOObjectResponseDTO>(null as any);
  }

  /**
   * Изменить данные модуля
   * @param body (optional) Объект с данными модуля
   * @return Возвращает сообщение об успехе, если удалось изменить модуль
   */
  updateModule(
    body: ModuleDTO | undefined
  ): Promise<ModuleDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/module/update-module";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateModule(_response);
    });
  }

  protected processUpdateModule(
    response: Response
  ): Promise<ModuleDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ModuleDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ModuleDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u043c\u043e\u0434\u0443\u043b\u044c",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ModuleDTOObjectResponseDTO>(null as any);
  }

  /**
   * Передать модуль компании
   * @param uVI (optional) Уникальный идентификатор транспортного средства
   * @param companyId (optional) Id компании
   * @return Возвращает сообщение об успехе, если удалось передать модуль
   */
  transferModuleToCompany(
    uVI: string | undefined,
    companyId: string | undefined
  ): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/services/module/transfer-module-to-company?";
    if (uVI === null) throw new Error("The parameter 'uVI' cannot be null.");
    else if (uVI !== undefined)
      url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    if (companyId === null)
      throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined)
      url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processTransferModuleToCompany(_response);
    });
  }

  protected processTransferModuleToCompany(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u0435\u0440\u0435\u0434\u0430\u0442\u044c \u043c\u043e\u0434\u0443\u043b\u044c",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Отправить команду на сброс
   * @param uVI Уникальный идентификатор транспортного средства
   * @return Возвращает сообщение об успехе, если удалось отправить команду на сброс
   */
  resetModule(uVI: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/services/module/reset-module?";
    if (uVI === undefined || uVI === null)
      throw new Error(
        "The parameter 'uVI' must be defined and cannot be null."
      );
    else url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processResetModule(_response);
    });
  }

  protected processResetModule(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043a\u043e\u043c\u0430\u043d\u0434\u0443 \u043d\u0430 \u0441\u0431\u0440\u043e\u0441",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Синхронизировать настройки модуля
   * @param uVI Уникальный идентификатор транспортного средства
   * @return Возвращает сообщение об успехе, если удалось отправить настройки в модуль (начать синхронизацию)
   */
  synchronizeModuleSettings(uVI: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/services/module/synchronize-module-settings?";
    if (uVI === undefined || uVI === null)
      throw new Error(
        "The parameter 'uVI' must be defined and cannot be null."
      );
    else url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSynchronizeModuleSettings(_response);
    });
  }

  protected processSynchronizeModuleSettings(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438 \u0432 \u043c\u043e\u0434\u0443\u043b\u044c",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Получить историю (логи) подключений/отключений модуля
   * @param uVI Уникальный идентификатор транспортного средства
   * @return Возвращает сообщение об успехе, если удалось получить историю
   */
  getModuleConnections(
    uVI: string
  ): Promise<ModuleConnectionDTOListResponseDTO> {
    let url_ = this.baseUrl + "/services/module/get-module-connections?";
    if (uVI === undefined || uVI === null)
      throw new Error(
        "The parameter 'uVI' must be defined and cannot be null."
      );
    else url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetModuleConnections(_response);
    });
  }

  protected processGetModuleConnections(
    response: Response
  ): Promise<ModuleConnectionDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ModuleConnectionDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ModuleConnectionDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0438\u0441\u0442\u043e\u0440\u0438\u044e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ModuleConnectionDTOListResponseDTO>(null as any);
  }

  /**
   * Очистить историю (логи) подключений/отключений модуля
   * @param uVI Уникальный идентификатор транспортного средства
   * @return Возвращает сообщение об успехе, если удалось очистить историю
   */
  clearConnectionLogs(uVI: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/services/module/clear-connection-logs?";
    if (uVI === undefined || uVI === null)
      throw new Error(
        "The parameter 'uVI' must be defined and cannot be null."
      );
    else url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processClearConnectionLogs(_response);
    });
  }

  protected processClearConnectionLogs(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0447\u0438\u0441\u0442\u0438\u0442\u044c \u0438\u0441\u0442\u043e\u0440\u0438\u044e",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Отправить настройки модуля по SMS
   * @param uVI Уникальный идентификатор транспортного средства
   * @return Возвращает сообщение об успехе, если удалось отправить настройки модуля
   */
  sendModuleSettingsViaSms(uVI: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/services/module/send-module-settings-via-sms?";
    if (uVI === undefined || uVI === null)
      throw new Error(
        "The parameter 'uVI' must be defined and cannot be null."
      );
    else url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSendModuleSettingsViaSms(_response);
    });
  }

  protected processSendModuleSettingsViaSms(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438 \u043c\u043e\u0434\u0443\u043b\u044f",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Отправить настройки подключения к брокеру по SMS
   * @param companyId Id компании
   * @param body (optional) Список уникальных идентификаторов транспортных средств
   * @return Возвращает сообщение об успехе, если удалось отправить настройки подключения к брокеру
   */
  sendConnectionSettingsViaSms(
    companyId: string,
    body: string[] | undefined
  ): Promise<ResponseDTO> {
    let url_ =
      this.baseUrl + "/services/module/send-connection-settings-via-sms?";
    if (companyId === undefined || companyId === null)
      throw new Error(
        "The parameter 'companyId' must be defined and cannot be null."
      );
    else url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSendConnectionSettingsViaSms(_response);
    });
  }

  protected processSendConnectionSettingsViaSms(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438 \u043f\u043e\u0434\u043a\u043b\u044e\u0447\u0435\u043d\u0438\u044f \u043a \u0431\u0440\u043e\u043a\u0435\u0440\u0443",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Отправить настройки подключения к брокеру
   * @param companyId Id компании
   * @param body (optional) Список уникальных идентификаторов транспортных средств
   * @return Возвращает сообщение об успехе, если удалось отправить настройки подключения к брокеру
   */
  sendConnectionSettings(
    companyId: string,
    body: string[] | undefined
  ): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/services/module/send-connection-settings?";
    if (companyId === undefined || companyId === null)
      throw new Error(
        "The parameter 'companyId' must be defined and cannot be null."
      );
    else url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSendConnectionSettings(_response);
    });
  }

  protected processSendConnectionSettings(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438 \u043f\u043e\u0434\u043a\u043b\u044e\u0447\u0435\u043d\u0438\u044f \u043a \u0431\u0440\u043e\u043a\u0435\u0440\u0443",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Получить статистику для модуля (количество посланных сообщений и их размер)
   * @param uVI (optional) Уникальный идентификатор транспортного средства
   * @param firstDate (optional) Начальная дата
   * @param lastDate (optional) Конечная дата
   * @return Возвращает сообщение об успехе, если удалось получить статистику
   */
  getModuleStatistics(
    uVI: string | undefined,
    firstDate: Date | undefined,
    lastDate: Date | undefined
  ): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/services/module/get-module-statistics?";
    if (uVI === null) throw new Error("The parameter 'uVI' cannot be null.");
    else if (uVI !== undefined)
      url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    if (firstDate === null)
      throw new Error("The parameter 'firstDate' cannot be null.");
    else if (firstDate !== undefined)
      url_ +=
        "firstDate=" +
        encodeURIComponent(firstDate ? "" + firstDate.toISOString() : "") +
        "&";
    if (lastDate === null)
      throw new Error("The parameter 'lastDate' cannot be null.");
    else if (lastDate !== undefined)
      url_ +=
        "lastDate=" +
        encodeURIComponent(lastDate ? "" + lastDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetModuleStatistics(_response);
    });
  }

  protected processGetModuleStatistics(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0443",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Получение списка критериев для статусов по UVI (для всех функций с указанным UVI)
   * @param uVI Уникальный идентификатор транспортного средства
   * @return Возвращает сообщение об успехе, если удалось получить список критериев (и сам список)
   */
  getStatusCriteria(uVI: string): Promise<StatusCriterionDTOListResponseDTO> {
    let url_ = this.baseUrl + "/services/status-criteria/get-status-criteria?";
    if (uVI === undefined || uVI === null)
      throw new Error(
        "The parameter 'uVI' must be defined and cannot be null."
      );
    else url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetStatusCriteria(_response);
    });
  }

  protected processGetStatusCriteria(
    response: Response
  ): Promise<StatusCriterionDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StatusCriterionDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = StatusCriterionDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u043a\u0440\u0438\u0442\u0435\u0440\u0438\u0435\u0432",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StatusCriterionDTOListResponseDTO>(null as any);
  }

  /**
   * Получение списка критериев для статусов по Id функции
   * @param functionId Id функции
   * @return Возвращает сообщение об успехе, если удалось получить список критериев (и сам список)
   */
  getStatusCriteriaByFunctionId(
    functionId: string
  ): Promise<StatusCriterionDTOListResponseDTO> {
    let url_ =
      this.baseUrl +
      "/services/status-criteria/get-status-criteria-by-function-id?";
    if (functionId === undefined || functionId === null)
      throw new Error(
        "The parameter 'functionId' must be defined and cannot be null."
      );
    else url_ += "functionId=" + encodeURIComponent("" + functionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetStatusCriteriaByFunctionId(_response);
    });
  }

  protected processGetStatusCriteriaByFunctionId(
    response: Response
  ): Promise<StatusCriterionDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StatusCriterionDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = StatusCriterionDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u043a\u0440\u0438\u0442\u0435\u0440\u0438\u0435\u0432",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StatusCriterionDTOListResponseDTO>(null as any);
  }

  /**
   * Редактирование критериев
   * @param functionId (optional) Id функции
   * @param body (optional) Список критериев
   * @return Возвращает сообщение об успехе, если удалось изменить критерии
   */
  updateStatusCriteria(
    functionId: string | undefined,
    body: StatusCriterionDTO[] | undefined
  ): Promise<StatusCriterionDTOListResponseDTO> {
    let url_ =
      this.baseUrl + "/services/status-criteria/update-status-criteria?";
    if (functionId === null)
      throw new Error("The parameter 'functionId' cannot be null.");
    else if (functionId !== undefined)
      url_ += "functionId=" + encodeURIComponent("" + functionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateStatusCriteria(_response);
    });
  }

  protected processUpdateStatusCriteria(
    response: Response
  ): Promise<StatusCriterionDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StatusCriterionDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = StatusCriterionDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u043a\u0440\u0438\u0442\u0435\u0440\u0438\u0438",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<StatusCriterionDTOListResponseDTO>(null as any);
  }

  /**
   * Получение списка параметров
   * @return Возвращает сообщение об успехе, если удалось получить список параметров (и сам список)
   */
  getCriteriaParameters(): Promise<CriterionParameterListResponseDTO> {
    let url_ =
      this.baseUrl + "/services/status-criteria/get-criteria-parameters";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCriteriaParameters(_response);
    });
  }

  protected processGetCriteriaParameters(
    response: Response
  ): Promise<CriterionParameterListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CriterionParameterListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CriterionParameterListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u043f\u0430\u0440\u0430\u043c\u0435\u0442\u0440\u043e\u0432",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CriterionParameterListResponseDTO>(null as any);
  }

  /**
   * Регистрация пользователя
   * @param body (optional) Данные пользователя из формы регистрации
   * @return Возвращает сообщение об успешной регистрации
   */
  register(body: UserRegisterDTO | undefined): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/user/register";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRegister(_response);
    });
  }

  protected processRegister(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        let resultData201 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result201 = ResponseDTO.fromJS(resultData201);
        return result201;
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null;
        let resultData409 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result409 = ResponseDTO.fromJS(resultData409);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0432\u0432\u0435\u0434\u0435\u043d\u043d\u044b\u0435 \u0434\u0430\u043d\u043d\u044b\u0435 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u043d\u044b",
          status,
          _responseText,
          _headers,
          result409
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Аутентификация пользователя
   * @param body (optional) Данные пользователя из формы входа
   * @return Возвращает сообщение об успешной аутентификации и JWT-токен
   */
  login(body: UserLoginDTO | undefined): Promise<LoginResponseDTO> {
    let url_ = this.baseUrl + "/user/login";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processLogin(_response);
    });
  }

  protected processLogin(response: Response): Promise<LoginResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = LoginResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = LoginResponseDTO.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0443\u0442\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<LoginResponseDTO>(null as any);
  }

  /**
   * Обновление jwt-токена
   * @param body (optional) Объект с Refresh-токеном и истекшим Access-токеном
   * @return Возвращает сообщение об успешном обновлении токенов и сами токены
   */
  refreshToken(body: TokensDTO | undefined): Promise<LoginResponseDTO> {
    let url_ = this.baseUrl + "/user/refresh-token";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRefreshToken(_response);
    });
  }

  protected processRefreshToken(response: Response): Promise<LoginResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = LoginResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = LoginResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0431\u043d\u043e\u0432\u0438\u0442\u044c \u0442\u043e\u043a\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<LoginResponseDTO>(null as any);
  }

  /**
   * Отправка письма для подтверждения регистрации
   * @param email Почта пользователя
   * @return Возвращает сообщение об успехе, если удалось отправить сообщение на почту
   */
  sendConfirmationEmail(email: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/user/send-confirmation-email?";
    if (email === undefined || email === null)
      throw new Error(
        "The parameter 'email' must be defined and cannot be null."
      );
    else url_ += "email=" + encodeURIComponent("" + email) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSendConfirmationEmail(_response);
    });
  }

  protected processSendConfirmationEmail(
    response: Response
  ): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043d\u0430 \u043f\u043e\u0447\u0442\u0443",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Подтверждение почты
   * @param email Электронная почта пользователя
   * @param emailConfirmationToken Токен подтверждения почты
   */
  confirmEmail(email: string, emailConfirmationToken: string): Promise<void> {
    let url_ = this.baseUrl + "/user/confirm-email?";
    if (email === undefined || email === null)
      throw new Error(
        "The parameter 'email' must be defined and cannot be null."
      );
    else url_ += "email=" + encodeURIComponent("" + email) + "&";
    if (emailConfirmationToken === undefined || emailConfirmationToken === null)
      throw new Error(
        "The parameter 'emailConfirmationToken' must be defined and cannot be null."
      );
    else
      url_ +=
        "emailConfirmationToken=" +
        encodeURIComponent("" + emailConfirmationToken) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processConfirmEmail(_response);
    });
  }

  protected processConfirmEmail(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 302) {
      return response.text().then((_responseText) => {
        return throwException(
          "\u041f\u0440\u043e\u0438\u0441\u0445\u043e\u0434\u0438\u0442 \u043f\u0435\u0440\u0435\u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0435 \u043d\u0430 \u0433\u043b\u0430\u0432\u043d\u0443\u044e \u0441\u0442\u0440\u0430\u043d\u0438\u0446\u0443",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u043f\u043e\u0447\u0442\u0443",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Отправка письма для сброса пароля
   * @param body (optional) Объект с почтой пользователя
   * @return Возвращает сообщение об успехе, если удалось отправить сообщение на почту
   */
  sendResetPasswordEmail(
    body: ResetPasswordEmail | undefined
  ): Promise<ResetPasswordResponseDTO> {
    let url_ = this.baseUrl + "/user/send-reset-password-email";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSendResetPasswordEmail(_response);
    });
  }

  protected processSendResetPasswordEmail(
    response: Response
  ): Promise<ResetPasswordResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResetPasswordResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResetPasswordResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043d\u0430 \u043f\u043e\u0447\u0442\u0443",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResetPasswordResponseDTO>(null as any);
  }

  /**
   * Сброс пароля
   * @param body (optional) Объект с новым паролем, email и токеном сброса пароля
   * @return Возвращает сообщение об успехе, если удалось сбросить пароль
   */
  resetPassword(body: ResetPasswordDTO | undefined): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/user/reset-password";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processResetPassword(_response);
    });
  }

  protected processResetPassword(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0441\u0431\u0440\u043e\u0441\u0438\u0442\u044c \u043f\u0430\u0440\u043e\u043b\u044c",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Получение профиля текущего пользователя
   * @return Возвращает объект с данными профиля пользователя
   */
  getUserProfile(): Promise<UserProfileDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/user-profile/get-user-profile";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUserProfile(_response);
    });
  }

  protected processGetUserProfile(
    response: Response
  ): Promise<UserProfileDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UserProfileDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = UserProfileDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<UserProfileDTOObjectResponseDTO>(null as any);
  }

  /**
   * Изменения пароля
   * @param body (optional) Объект с текущим паролем и новым паролем
   * @return Возвращает сообщение об успехе, если удалось изменить пароль
   */
  changePassword(body: ChangePasswordDTO | undefined): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/user-profile/change-password";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processChangePassword(_response);
    });
  }

  protected processChangePassword(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u043f\u0430\u0440\u043e\u043b\u044c",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Получение списка транспортных средств
   * @return Возвращает сообщение об успехе, если удалось получить список транспортных средств (и сам список)
   */
  getVehicles(): Promise<VehicleDTOListResponseDTO> {
    let url_ = this.baseUrl + "/services/vehicle/get-vehicles";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetVehicles(_response);
    });
  }

  protected processGetVehicles(
    response: Response
  ): Promise<VehicleDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = VehicleDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = VehicleDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u0442\u0440\u0430\u043d\u0441\u043f\u043e\u0440\u0442\u043d\u044b\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<VehicleDTOListResponseDTO>(null as any);
  }

  /**
   * Получение транспортного средства по Id
   * @param id Id транспортного средства
   * @return Возвращает объект с информацией о выбранном транспортном средстве
   */
  getVehicleById(id: string): Promise<VehicleDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/vehicle/get-vehicle-by-id?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetVehicleById(_response);
    });
  }

  protected processGetVehicleById(
    response: Response
  ): Promise<VehicleDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = VehicleDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = VehicleDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<VehicleDTOObjectResponseDTO>(null as any);
  }

  /**
   * Получение транспортного средства по Imei
   * @param imei Imei транспортного средства
   * @return Возвращает объект с информацией о выбранном транспортном средстве
   */
  getVehicleByImei(imei: string): Promise<VehicleDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/vehicle/get-vehicle-by-imei?";
    if (imei === undefined || imei === null)
      throw new Error(
        "The parameter 'imei' must be defined and cannot be null."
      );
    else url_ += "Imei=" + encodeURIComponent("" + imei) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetVehicleByImei(_response);
    });
  }

  protected processGetVehicleByImei(
    response: Response
  ): Promise<VehicleDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = VehicleDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = VehicleDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<VehicleDTOObjectResponseDTO>(null as any);
  }

  /**
   * Получение транспортного средства по Uvi
   * @param uvi Уникальный идентификатор транспортного средства
   * @return Возвращает объект с информацией о выбранном транспортном средстве
   */
  getVehicleByUvi(uvi: string): Promise<VehicleDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/vehicle/get-vehicle-by-uvi?";
    if (uvi === undefined || uvi === null)
      throw new Error(
        "The parameter 'uvi' must be defined and cannot be null."
      );
    else url_ += "Uvi=" + encodeURIComponent("" + uvi) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetVehicleByUvi(_response);
    });
  }

  protected processGetVehicleByUvi(
    response: Response
  ): Promise<VehicleDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = VehicleDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = VehicleDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<VehicleDTOObjectResponseDTO>(null as any);
  }

  /**
   * Создание транспортного средства
   * @param body (optional) Модель с данными транспортного средства
   * @return Возвращает сообщение об успехе, если удалось создать новый транспорт
   */
  createVehicle(
    body: VehicleDTO | undefined
  ): Promise<VehicleDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/vehicle/create-vehicle";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateVehicle(_response);
    });
  }

  protected processCreateVehicle(
    response: Response
  ): Promise<VehicleDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = VehicleDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = VehicleDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<VehicleDTOObjectResponseDTO>(null as any);
  }

  /**
   * Создать несколько транспортных средств и модулей (сгенерировать UVI)
   * @param count (optional) Количество UVI
   * @return Возвращает сообщение об успехе, если удалось создать транспортные средства
   */
  createVehicles(
    count: number | undefined
  ): Promise<VehicleDTOListResponseDTO> {
    let url_ = this.baseUrl + "/services/vehicle/create-vehicles?";
    if (count === null)
      throw new Error("The parameter 'count' cannot be null.");
    else if (count !== undefined)
      url_ += "count=" + encodeURIComponent("" + count) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateVehicles(_response);
    });
  }

  protected processCreateVehicles(
    response: Response
  ): Promise<VehicleDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = VehicleDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = VehicleDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u0441\u043e\u0437\u0434\u0430\u0442\u044c \u0442\u0440\u0430\u043d\u0441\u043f\u043e\u0440\u0442\u043d\u044b\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<VehicleDTOListResponseDTO>(null as any);
  }

  /**
   * Редактирование транспортного средства
   * @param body (optional) Модель с данными транспортного средства
   * @return Возвращает сообщение об успехе, если удалось изменить транспорт
   */
  updateVehicle(body: VehicleDTO | undefined): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/services/vehicle/update-vehicle";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateVehicle(_response);
    });
  }

  protected processUpdateVehicle(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Удаление транспортного средства по Id
   * @param id Id транспортного средства
   * @return Возвращает сообщение об успехе, если удалось удалить транспорт
   */
  deleteVehicle(id: string): Promise<ResponseDTO> {
    let url_ = this.baseUrl + "/services/vehicle/delete-vehicle?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    else url_ += "Id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteVehicle(_response);
    });
  }

  protected processDeleteVehicle(response: Response): Promise<ResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u0437\u0430\u043f\u0440\u043e\u0441 \u043d\u0435\u043a\u043e\u0440\u0440\u0435\u043a\u0442\u0435\u043d",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null;
        let resultData403 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result403 = ProblemDetails.fromJS(resultData403);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e \u0437\u0430\u043f\u0440\u0435\u0442\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u0430",
          status,
          _responseText,
          _headers,
          result403
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ResponseDTO>(null as any);
  }

  /**
   * Получение типов транспортных средств
   * @return Возвращает сообщение об успехе, если удалось получить список типов транспортных средств (и сам список)
   */
  getVehicleTypes(): Promise<VehicleTypeListResponseDTO> {
    let url_ = this.baseUrl + "/services/vehicle/get-vehicle-types";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetVehicleTypes(_response);
    });
  }

  protected processGetVehicleTypes(
    response: Response
  ): Promise<VehicleTypeListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = VehicleTypeListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = VehicleTypeListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0441\u043f\u0438\u0441\u043e\u043a \u0442\u0438\u043f\u043e\u0432 \u0442\u0440\u0430\u043d\u0441\u043f\u043e\u0440\u0442\u043d\u044b\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<VehicleTypeListResponseDTO>(null as any);
  }

  /**
   * Получить хронологию передвижений транспортного средства (маршрут)
   * @param uVI (optional) Уникальный идентификатор транспортного средства
   * @param firstDate (optional) Начальная дата
   * @param lastDate (optional) Конечная дата
   * @param kink (optional) Погрешность в метрах
   * @return Возвращает сообщение об успехе, если удалось получить хронологию передвижений транспортного средства (маршрут)
   */
  getVehicleRoute(
    uVI: string | undefined,
    firstDate: Date | undefined,
    lastDate: Date | undefined,
    kink: number | undefined
  ): Promise<CoordinatesMessageDTOListResponseDTO> {
    let url_ = this.baseUrl + "/services/vehicle/get-vehicle-route?";
    if (uVI === null) throw new Error("The parameter 'uVI' cannot be null.");
    else if (uVI !== undefined)
      url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    if (firstDate === null)
      throw new Error("The parameter 'firstDate' cannot be null.");
    else if (firstDate !== undefined)
      url_ +=
        "firstDate=" +
        encodeURIComponent(firstDate ? "" + firstDate.toISOString() : "") +
        "&";
    if (lastDate === null)
      throw new Error("The parameter 'lastDate' cannot be null.");
    else if (lastDate !== undefined)
      url_ +=
        "lastDate=" +
        encodeURIComponent(lastDate ? "" + lastDate.toISOString() : "") +
        "&";
    if (kink === null) throw new Error("The parameter 'kink' cannot be null.");
    else if (kink !== undefined)
      url_ += "kink=" + encodeURIComponent("" + kink) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetVehicleRoute(_response);
    });
  }

  protected processGetVehicleRoute(
    response: Response
  ): Promise<CoordinatesMessageDTOListResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CoordinatesMessageDTOListResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CoordinatesMessageDTOListResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0445\u0440\u043e\u043d\u043e\u043b\u043e\u0433\u0438\u044e \u043f\u0435\u0440\u0435\u0434\u0432\u0438\u0436\u0435\u043d\u0438\u0439 \u0442\u0440\u0430\u043d\u0441\u043f\u043e\u0440\u0442\u043d\u043e\u0433\u043e \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 (\u043c\u0430\u0440\u0448\u0440\u0443\u0442)",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CoordinatesMessageDTOListResponseDTO>(null as any);
  }

  /**
   * Получить координаты транспортного средства по дате (приближенно к указанной дате)
   * @param uVI (optional) Уникальный идентификатор транспортного средства
   * @param date (optional) Дата (если дата не указана, то будут найдены последние координаты)
   * @return Возвращает сообщение об успехе, если удалось получить хронологию передвижений транспортного средства (маршрут)
   */
  getVehicleCoordinates(
    uVI: string | undefined,
    date: Date | undefined
  ): Promise<CoordinatesMessageDTOObjectResponseDTO> {
    let url_ = this.baseUrl + "/services/vehicle/get-vehicle-coordinates?";
    if (uVI === null) throw new Error("The parameter 'uVI' cannot be null.");
    else if (uVI !== undefined)
      url_ += "UVI=" + encodeURIComponent("" + uVI) + "&";
    if (date === null) throw new Error("The parameter 'date' cannot be null.");
    else if (date !== undefined)
      url_ +=
        "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetVehicleCoordinates(_response);
    });
  }

  protected processGetVehicleCoordinates(
    response: Response
  ): Promise<CoordinatesMessageDTOObjectResponseDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 =
          CoordinatesMessageDTOObjectResponseDTO.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 =
          CoordinatesMessageDTOObjectResponseDTO.fromJS(resultData400);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435, \u0435\u0441\u043b\u0438 \u043d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u044c \u0445\u0440\u043e\u043d\u043e\u043b\u043e\u0433\u0438\u044e \u043f\u0435\u0440\u0435\u0434\u0432\u0438\u0436\u0435\u043d\u0438\u0439 \u0442\u0440\u0430\u043d\u0441\u043f\u043e\u0440\u0442\u043d\u043e\u0433\u043e \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 (\u043c\u0430\u0440\u0448\u0440\u0443\u0442)",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        let resultData401 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result401 = ProblemDetails.fromJS(resultData401);
        return throwException(
          "\u0412\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u0435 \u043e\u0431 \u043e\u0448\u0438\u0431\u043a\u0435 \u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
          status,
          _responseText,
          _headers,
          result401
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CoordinatesMessageDTOObjectResponseDTO>(null as any);
  }
}

/** Действие пользователя (история действий) */
export class ActionHistory implements IActionHistory {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** IP-пользователя */
  ip?: string | undefined;
  /** Идентификатор пользователя (внешний ключ) */
  userId?: string | undefined;
  user?: ApplicationUser;
  actionType?: ActionType;
  /** Объект с изменненными (Create, Update, Delete) данными */
  data?: string | undefined;
  /** Идентификатор измененного объекта */
  dataId?: string | undefined;
  entity?: Entity;
  /** Дата */
  date?: Date;

  constructor(data?: IActionHistory) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.ip = _data["ip"];
      this.userId = _data["userId"];
      this.user = _data["user"]
        ? ApplicationUser.fromJS(_data["user"])
        : <any>undefined;
      this.actionType = _data["actionType"];
      this.data = _data["data"];
      this.dataId = _data["dataId"];
      this.entity = _data["entity"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): ActionHistory {
    data = typeof data === "object" ? data : {};
    let result = new ActionHistory();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["ip"] = this.ip;
    data["userId"] = this.userId;
    data["user"] = this.user ? this.user.toJSON() : <any>undefined;
    data["actionType"] = this.actionType;
    data["data"] = this.data;
    data["dataId"] = this.dataId;
    data["entity"] = this.entity;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

/** Действие пользователя (история действий) */
export interface IActionHistory {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** IP-пользователя */
  ip?: string | undefined;
  /** Идентификатор пользователя (внешний ключ) */
  userId?: string | undefined;
  user?: ApplicationUser;
  actionType?: ActionType;
  /** Объект с изменненными (Create, Update, Delete) данными */
  data?: string | undefined;
  /** Идентификатор измененного объекта */
  dataId?: string | undefined;
  entity?: Entity;
  /** Дата */
  date?: Date;
}

/** Тип действия */
export enum ActionType {
  Create = 1,
  Update = 2,
  Delete = 3,
  Login = 4,
  ConfirmEmail = 5,
  SendResetPasswordEmail = 6,
  ResetPassword = 7,
  SendConfirmationEmail = 8,
  ChangePassword = 9,
}

/** Пользователь (сущность) */
export class ApplicationUser implements IApplicationUser {
  id?: string;
  userName?: string | undefined;
  normalizedUserName?: string | undefined;
  email?: string | undefined;
  normalizedEmail?: string | undefined;
  emailConfirmed?: boolean;
  passwordHash?: string | undefined;
  securityStamp?: string | undefined;
  concurrencyStamp?: string | undefined;
  phoneNumber?: string | undefined;
  phoneNumberConfirmed?: boolean;
  twoFactorEnabled?: boolean;
  lockoutEnd?: Date | undefined;
  lockoutEnabled?: boolean;
  accessFailedCount?: number;
  /** Логин */
  login?: string | undefined;
  /** Идентификатор компании (внешний ключ) */
  companyId?: string | undefined;
  company?: Company;
  /** Имя */
  firstName?: string | undefined;
  /** Фамилия */
  secondName?: string | undefined;
  /** Дата рождения */
  dateBirth?: Date | undefined;
  gender?: Gender;
  /** Refresh-токен */
  refreshToken?: string | undefined;
  /** Дата истечения refresh-токена */
  refreshTokenExpiryTime?: Date | undefined;
  /** Дата создания (регистрации) */
  creationDate?: Date | undefined;
  /** История действий (навигационное свойство) */
  actions?: ActionHistory[] | undefined;

  constructor(data?: IApplicationUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.userName = _data["userName"];
      this.normalizedUserName = _data["normalizedUserName"];
      this.email = _data["email"];
      this.normalizedEmail = _data["normalizedEmail"];
      this.emailConfirmed = _data["emailConfirmed"];
      this.passwordHash = _data["passwordHash"];
      this.securityStamp = _data["securityStamp"];
      this.concurrencyStamp = _data["concurrencyStamp"];
      this.phoneNumber = _data["phoneNumber"];
      this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
      this.twoFactorEnabled = _data["twoFactorEnabled"];
      this.lockoutEnd = _data["lockoutEnd"]
        ? new Date(_data["lockoutEnd"].toString())
        : <any>undefined;
      this.lockoutEnabled = _data["lockoutEnabled"];
      this.accessFailedCount = _data["accessFailedCount"];
      this.login = _data["login"];
      this.companyId = _data["companyId"];
      this.company = _data["company"]
        ? Company.fromJS(_data["company"])
        : <any>undefined;
      this.firstName = _data["firstName"];
      this.secondName = _data["secondName"];
      this.dateBirth = _data["dateBirth"]
        ? new Date(_data["dateBirth"].toString())
        : <any>undefined;
      this.gender = _data["gender"];
      this.refreshToken = _data["refreshToken"];
      this.refreshTokenExpiryTime = _data["refreshTokenExpiryTime"]
        ? new Date(_data["refreshTokenExpiryTime"].toString())
        : <any>undefined;
      this.creationDate = _data["creationDate"]
        ? new Date(_data["creationDate"].toString())
        : <any>undefined;
      if (Array.isArray(_data["actions"])) {
        this.actions = [] as any;
        for (let item of _data["actions"])
          this.actions!.push(ActionHistory.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ApplicationUser {
    data = typeof data === "object" ? data : {};
    let result = new ApplicationUser();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["userName"] = this.userName;
    data["normalizedUserName"] = this.normalizedUserName;
    data["email"] = this.email;
    data["normalizedEmail"] = this.normalizedEmail;
    data["emailConfirmed"] = this.emailConfirmed;
    data["passwordHash"] = this.passwordHash;
    data["securityStamp"] = this.securityStamp;
    data["concurrencyStamp"] = this.concurrencyStamp;
    data["phoneNumber"] = this.phoneNumber;
    data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
    data["twoFactorEnabled"] = this.twoFactorEnabled;
    data["lockoutEnd"] = this.lockoutEnd
      ? this.lockoutEnd.toISOString()
      : <any>undefined;
    data["lockoutEnabled"] = this.lockoutEnabled;
    data["accessFailedCount"] = this.accessFailedCount;
    data["login"] = this.login;
    data["companyId"] = this.companyId;
    data["company"] = this.company ? this.company.toJSON() : <any>undefined;
    data["firstName"] = this.firstName;
    data["secondName"] = this.secondName;
    data["dateBirth"] = this.dateBirth
      ? this.dateBirth.toISOString()
      : <any>undefined;
    data["gender"] = this.gender;
    data["refreshToken"] = this.refreshToken;
    data["refreshTokenExpiryTime"] = this.refreshTokenExpiryTime
      ? this.refreshTokenExpiryTime.toISOString()
      : <any>undefined;
    data["creationDate"] = this.creationDate
      ? this.creationDate.toISOString()
      : <any>undefined;
    if (Array.isArray(this.actions)) {
      data["actions"] = [];
      for (let item of this.actions) data["actions"].push(item.toJSON());
    }
    return data;
  }
}

/** Пользователь (сущность) */
export interface IApplicationUser {
  id?: string;
  userName?: string | undefined;
  normalizedUserName?: string | undefined;
  email?: string | undefined;
  normalizedEmail?: string | undefined;
  emailConfirmed?: boolean;
  passwordHash?: string | undefined;
  securityStamp?: string | undefined;
  concurrencyStamp?: string | undefined;
  phoneNumber?: string | undefined;
  phoneNumberConfirmed?: boolean;
  twoFactorEnabled?: boolean;
  lockoutEnd?: Date | undefined;
  lockoutEnabled?: boolean;
  accessFailedCount?: number;
  /** Логин */
  login?: string | undefined;
  /** Идентификатор компании (внешний ключ) */
  companyId?: string | undefined;
  company?: Company;
  /** Имя */
  firstName?: string | undefined;
  /** Фамилия */
  secondName?: string | undefined;
  /** Дата рождения */
  dateBirth?: Date | undefined;
  gender?: Gender;
  /** Refresh-токен */
  refreshToken?: string | undefined;
  /** Дата истечения refresh-токена */
  refreshTokenExpiryTime?: Date | undefined;
  /** Дата создания (регистрации) */
  creationDate?: Date | undefined;
  /** История действий (навигационное свойство) */
  actions?: ActionHistory[] | undefined;
}

export class CanIdentifierDTO implements ICanIdentifierDTO {
  errors?: { [key: string]: string[] } | undefined;
  id?: string | undefined;
  uvi!: string;
  name?: string | undefined;
  canId!: string;
  mask!: string;
  pgn?: number | undefined;
  index?: number | undefined;
  hexIndex?: string | undefined;
  period?: number;
  protocol?: Protocol;
  format?: Format;
  configurationConfirmed?: boolean;

  constructor(data?: ICanIdentifierDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.uvi = _data["uvi"];
      this.name = _data["name"];
      this.canId = _data["canId"];
      this.mask = _data["mask"];
      this.pgn = _data["pgn"];
      this.index = _data["index"];
      this.hexIndex = _data["hexIndex"];
      this.period = _data["period"];
      this.protocol = _data["protocol"];
      this.format = _data["format"];
      this.configurationConfirmed = _data["configurationConfirmed"];
    }
  }

  static fromJS(data: any): CanIdentifierDTO {
    data = typeof data === "object" ? data : {};
    let result = new CanIdentifierDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["uvi"] = this.uvi;
    data["name"] = this.name;
    data["canId"] = this.canId;
    data["mask"] = this.mask;
    data["pgn"] = this.pgn;
    data["index"] = this.index;
    data["hexIndex"] = this.hexIndex;
    data["period"] = this.period;
    data["protocol"] = this.protocol;
    data["format"] = this.format;
    data["configurationConfirmed"] = this.configurationConfirmed;
    return data;
  }
}

export interface ICanIdentifierDTO {
  errors?: { [key: string]: string[] } | undefined;
  id?: string | undefined;
  uvi: string;
  name?: string | undefined;
  canId: string;
  mask: string;
  pgn?: number | undefined;
  index?: number | undefined;
  hexIndex?: string | undefined;
  period?: number;
  protocol?: Protocol;
  format?: Format;
  configurationConfirmed?: boolean;
}

export class CanIdentifierDTOListResponseDTO
  implements ICanIdentifierDTOListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CanIdentifierDTO[] | undefined;

  constructor(data?: ICanIdentifierDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(CanIdentifierDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CanIdentifierDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new CanIdentifierDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICanIdentifierDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CanIdentifierDTO[] | undefined;
}

export class CanMessageDTO implements ICanMessageDTO {
  errors?: { [key: string]: string[] } | undefined;
  id?: string;
  uvi?: string | undefined;
  canId?: string | undefined;
  dlc?: number;
  dataByte0?: string | undefined;
  dataByte1?: string | undefined;
  dataByte2?: string | undefined;
  dataByte3?: string | undefined;
  dataByte4?: string | undefined;
  dataByte5?: string | undefined;
  dataByte6?: string | undefined;
  dataByte7?: string | undefined;
  messageDate?: Date | undefined;
  recordDate?: Date;
  number?: number;

  constructor(data?: ICanMessageDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.uvi = _data["uvi"];
      this.canId = _data["canId"];
      this.dlc = _data["dlc"];
      this.dataByte0 = _data["dataByte0"];
      this.dataByte1 = _data["dataByte1"];
      this.dataByte2 = _data["dataByte2"];
      this.dataByte3 = _data["dataByte3"];
      this.dataByte4 = _data["dataByte4"];
      this.dataByte5 = _data["dataByte5"];
      this.dataByte6 = _data["dataByte6"];
      this.dataByte7 = _data["dataByte7"];
      this.messageDate = _data["messageDate"]
        ? new Date(_data["messageDate"].toString())
        : <any>undefined;
      this.recordDate = _data["recordDate"]
        ? new Date(_data["recordDate"].toString())
        : <any>undefined;
      this.number = _data["number"];
    }
  }

  static fromJS(data: any): CanMessageDTO {
    data = typeof data === "object" ? data : {};
    let result = new CanMessageDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["uvi"] = this.uvi;
    data["canId"] = this.canId;
    data["dlc"] = this.dlc;
    data["dataByte0"] = this.dataByte0;
    data["dataByte1"] = this.dataByte1;
    data["dataByte2"] = this.dataByte2;
    data["dataByte3"] = this.dataByte3;
    data["dataByte4"] = this.dataByte4;
    data["dataByte5"] = this.dataByte5;
    data["dataByte6"] = this.dataByte6;
    data["dataByte7"] = this.dataByte7;
    data["messageDate"] = this.messageDate
      ? this.messageDate.toISOString()
      : <any>undefined;
    data["recordDate"] = this.recordDate
      ? this.recordDate.toISOString()
      : <any>undefined;
    data["number"] = this.number;
    return data;
  }
}

export interface ICanMessageDTO {
  errors?: { [key: string]: string[] } | undefined;
  id?: string;
  uvi?: string | undefined;
  canId?: string | undefined;
  dlc?: number;
  dataByte0?: string | undefined;
  dataByte1?: string | undefined;
  dataByte2?: string | undefined;
  dataByte3?: string | undefined;
  dataByte4?: string | undefined;
  dataByte5?: string | undefined;
  dataByte6?: string | undefined;
  dataByte7?: string | undefined;
  messageDate?: Date | undefined;
  recordDate?: Date;
  number?: number;
}

export class CanMessageDTOListResponseDTO
  implements ICanMessageDTOListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CanMessageDTO[] | undefined;

  constructor(data?: ICanMessageDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(CanMessageDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CanMessageDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new CanMessageDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICanMessageDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CanMessageDTO[] | undefined;
}

/** Модель для изменения пароля */
export class ChangePasswordDTO implements IChangePasswordDTO {
  /** Новый пароль */
  newPassword!: string;
  /** Текущий пароль */
  currentPassword!: string;

  constructor(data?: IChangePasswordDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.newPassword = _data["newPassword"];
      this.currentPassword = _data["currentPassword"];
    }
  }

  static fromJS(data: any): ChangePasswordDTO {
    data = typeof data === "object" ? data : {};
    let result = new ChangePasswordDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["newPassword"] = this.newPassword;
    data["currentPassword"] = this.currentPassword;
    return data;
  }
}

/** Модель для изменения пароля */
export interface IChangePasswordDTO {
  /** Новый пароль */
  newPassword: string;
  /** Текущий пароль */
  currentPassword: string;
}

/** Компания (сущность) */
export class Company implements ICompany {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** Название */
  name?: string | undefined;
  /** Название компании для docker */
  dockerName?: string | undefined;
  /** Уникальный номер компании (токен) */
  token?: string | undefined;
  /** Адрес сервера */
  host?: string | undefined;
  /** Адрес резервного сервера */
  backupHost?: string | undefined;
  /** Порт VehicleServer (API с запросами для транспортных средств) */
  vehiclePort?: number | undefined;
  /** Порт mqtt-брокера (Broker) */
  brokerPort?: number | undefined;
  /** Порт mqtt-сервера (Server) */
  serverPort?: number | undefined;
  /** Порт RabbitMQ */
  rabbitMQPort?: number | undefined;
  /** Порт сервера для записи can-данных в БД (первый сервер) */
  canDataServerPort_1?: number | undefined;
  /** Порт сервера для записи can-сообщений в БД (второй сервер) */
  canDataServerPort_2?: number | undefined;
  /** Порт БД */
  databasePort?: number | undefined;
  /** Время сохранения соединения */
  keepAliveInterval?: number | undefined;
  /** Email пользователя, аккаунт, которого используется для подключения к брокеру */
  userName?: string | undefined;
  /** Пароль пользователя, аккаунт, которого используется для подключения к брокеру */
  password?: string | undefined;
  secretCode?: string | undefined;
  /** Количество посланных СМС */
  sms?: number;
  /** Дата создания */
  creationDate?: Date;
  /** Пользователи (сотрудники) компании (навигационное свойство) */
  users?: ApplicationUser[] | undefined;
  /** Прошивки, которые может использовать компания (навигационное свойство) */
  firmwares?: Firmware[] | undefined;
  updateSessions?: UpdateSession[] | undefined;

  constructor(data?: ICompany) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.name = _data["name"];
      this.dockerName = _data["dockerName"];
      this.token = _data["token"];
      this.host = _data["host"];
      this.backupHost = _data["backupHost"];
      this.vehiclePort = _data["vehiclePort"];
      this.brokerPort = _data["brokerPort"];
      this.serverPort = _data["serverPort"];
      this.rabbitMQPort = _data["rabbitMQPort"];
      this.canDataServerPort_1 = _data["canDataServerPort_1"];
      this.canDataServerPort_2 = _data["canDataServerPort_2"];
      this.databasePort = _data["databasePort"];
      this.keepAliveInterval = _data["keepAliveInterval"];
      this.userName = _data["userName"];
      this.password = _data["password"];
      this.secretCode = _data["secretCode"];
      this.sms = _data["sms"];
      this.creationDate = _data["creationDate"]
        ? new Date(_data["creationDate"].toString())
        : <any>undefined;
      if (Array.isArray(_data["users"])) {
        this.users = [] as any;
        for (let item of _data["users"])
          this.users!.push(ApplicationUser.fromJS(item));
      }
      if (Array.isArray(_data["firmwares"])) {
        this.firmwares = [] as any;
        for (let item of _data["firmwares"])
          this.firmwares!.push(Firmware.fromJS(item));
      }
      if (Array.isArray(_data["updateSessions"])) {
        this.updateSessions = [] as any;
        for (let item of _data["updateSessions"])
          this.updateSessions!.push(UpdateSession.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Company {
    data = typeof data === "object" ? data : {};
    let result = new Company();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["name"] = this.name;
    data["dockerName"] = this.dockerName;
    data["token"] = this.token;
    data["host"] = this.host;
    data["backupHost"] = this.backupHost;
    data["vehiclePort"] = this.vehiclePort;
    data["brokerPort"] = this.brokerPort;
    data["serverPort"] = this.serverPort;
    data["rabbitMQPort"] = this.rabbitMQPort;
    data["canDataServerPort_1"] = this.canDataServerPort_1;
    data["canDataServerPort_2"] = this.canDataServerPort_2;
    data["databasePort"] = this.databasePort;
    data["keepAliveInterval"] = this.keepAliveInterval;
    data["userName"] = this.userName;
    data["password"] = this.password;
    data["secretCode"] = this.secretCode;
    data["sms"] = this.sms;
    data["creationDate"] = this.creationDate
      ? this.creationDate.toISOString()
      : <any>undefined;
    if (Array.isArray(this.users)) {
      data["users"] = [];
      for (let item of this.users) data["users"].push(item.toJSON());
    }
    if (Array.isArray(this.firmwares)) {
      data["firmwares"] = [];
      for (let item of this.firmwares) data["firmwares"].push(item.toJSON());
    }
    if (Array.isArray(this.updateSessions)) {
      data["updateSessions"] = [];
      for (let item of this.updateSessions)
        data["updateSessions"].push(item.toJSON());
    }
    return data;
  }
}

/** Компания (сущность) */
export interface ICompany {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** Название */
  name?: string | undefined;
  /** Название компании для docker */
  dockerName?: string | undefined;
  /** Уникальный номер компании (токен) */
  token?: string | undefined;
  /** Адрес сервера */
  host?: string | undefined;
  /** Адрес резервного сервера */
  backupHost?: string | undefined;
  /** Порт VehicleServer (API с запросами для транспортных средств) */
  vehiclePort?: number | undefined;
  /** Порт mqtt-брокера (Broker) */
  brokerPort?: number | undefined;
  /** Порт mqtt-сервера (Server) */
  serverPort?: number | undefined;
  /** Порт RabbitMQ */
  rabbitMQPort?: number | undefined;
  /** Порт сервера для записи can-данных в БД (первый сервер) */
  canDataServerPort_1?: number | undefined;
  /** Порт сервера для записи can-сообщений в БД (второй сервер) */
  canDataServerPort_2?: number | undefined;
  /** Порт БД */
  databasePort?: number | undefined;
  /** Время сохранения соединения */
  keepAliveInterval?: number | undefined;
  /** Email пользователя, аккаунт, которого используется для подключения к брокеру */
  userName?: string | undefined;
  /** Пароль пользователя, аккаунт, которого используется для подключения к брокеру */
  password?: string | undefined;
  secretCode?: string | undefined;
  /** Количество посланных СМС */
  sms?: number;
  /** Дата создания */
  creationDate?: Date;
  /** Пользователи (сотрудники) компании (навигационное свойство) */
  users?: ApplicationUser[] | undefined;
  /** Прошивки, которые может использовать компания (навигационное свойство) */
  firmwares?: Firmware[] | undefined;
  updateSessions?: UpdateSession[] | undefined;
}

/** Компания (DTO) */
export class CompanyDTO implements ICompanyDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** Название */
  name!: string;
  /** Название компании для docker */
  dockerName!: string;
  /** Уникальный номер компании (токен) */
  token?: string | undefined;
  /** Секретный код для создания токена */
  secretCode?: string | undefined;
  /** Адрес сервера */
  host!: string;
  /** Адрес резервного сервера */
  backupHost?: string | undefined;
  /** Порт VehicleServer (API с запросами для транспортных средств) */
  vehiclePort?: number | undefined;
  /** Порт mqtt-брокера (Broker) */
  brokerPort?: number | undefined;
  /** Порт mqtt-сервера (Server) */
  serverPort?: number | undefined;
  /** Порт RabbitMQ */
  rabbitMQPort?: number | undefined;
  /** Порт сервера для записи can-данных в БД (первый сервер) */
  canDataServerPort_1?: number | undefined;
  /** Порт сервера для записи can-сообщений в БД (второй сервер) */
  canDataServerPort_2?: number | undefined;
  /** Порт БД */
  databasePort?: number | undefined;
  /** Время сохранения соединения модуля с брокером */
  keepAliveInterval?: number | undefined;
  /** Email пользователя, аккаунт, которого используется для подключения к брокеру */
  userName!: string;
  /** Пароль пользователя, аккаунт, которого используется для подключения к брокеру */
  password!: string;
  /** Количество посланных СМС */
  sms?: number;
  /** Дата создания */
  creationDate?: Date;

  constructor(data?: ICompanyDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.name = _data["name"];
      this.dockerName = _data["dockerName"];
      this.token = _data["token"];
      this.secretCode = _data["secretCode"];
      this.host = _data["host"];
      this.backupHost = _data["backupHost"];
      this.vehiclePort = _data["vehiclePort"];
      this.brokerPort = _data["brokerPort"];
      this.serverPort = _data["serverPort"];
      this.rabbitMQPort = _data["rabbitMQPort"];
      this.canDataServerPort_1 = _data["canDataServerPort_1"];
      this.canDataServerPort_2 = _data["canDataServerPort_2"];
      this.databasePort = _data["databasePort"];
      this.keepAliveInterval = _data["keepAliveInterval"];
      this.userName = _data["userName"];
      this.password = _data["password"];
      this.sms = _data["sms"];
      this.creationDate = _data["creationDate"]
        ? new Date(_data["creationDate"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): CompanyDTO {
    data = typeof data === "object" ? data : {};
    let result = new CompanyDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["name"] = this.name;
    data["dockerName"] = this.dockerName;
    data["token"] = this.token;
    data["secretCode"] = this.secretCode;
    data["host"] = this.host;
    data["backupHost"] = this.backupHost;
    data["vehiclePort"] = this.vehiclePort;
    data["brokerPort"] = this.brokerPort;
    data["serverPort"] = this.serverPort;
    data["rabbitMQPort"] = this.rabbitMQPort;
    data["canDataServerPort_1"] = this.canDataServerPort_1;
    data["canDataServerPort_2"] = this.canDataServerPort_2;
    data["databasePort"] = this.databasePort;
    data["keepAliveInterval"] = this.keepAliveInterval;
    data["userName"] = this.userName;
    data["password"] = this.password;
    data["sms"] = this.sms;
    data["creationDate"] = this.creationDate
      ? this.creationDate.toISOString()
      : <any>undefined;
    return data;
  }
}

/** Компания (DTO) */
export interface ICompanyDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** Название */
  name: string;
  /** Название компании для docker */
  dockerName: string;
  /** Уникальный номер компании (токен) */
  token?: string | undefined;
  /** Секретный код для создания токена */
  secretCode?: string | undefined;
  /** Адрес сервера */
  host: string;
  /** Адрес резервного сервера */
  backupHost?: string | undefined;
  /** Порт VehicleServer (API с запросами для транспортных средств) */
  vehiclePort?: number | undefined;
  /** Порт mqtt-брокера (Broker) */
  brokerPort?: number | undefined;
  /** Порт mqtt-сервера (Server) */
  serverPort?: number | undefined;
  /** Порт RabbitMQ */
  rabbitMQPort?: number | undefined;
  /** Порт сервера для записи can-данных в БД (первый сервер) */
  canDataServerPort_1?: number | undefined;
  /** Порт сервера для записи can-сообщений в БД (второй сервер) */
  canDataServerPort_2?: number | undefined;
  /** Порт БД */
  databasePort?: number | undefined;
  /** Время сохранения соединения модуля с брокером */
  keepAliveInterval?: number | undefined;
  /** Email пользователя, аккаунт, которого используется для подключения к брокеру */
  userName: string;
  /** Пароль пользователя, аккаунт, которого используется для подключения к брокеру */
  password: string;
  /** Количество посланных СМС */
  sms?: number;
  /** Дата создания */
  creationDate?: Date;
}

export class CompanyDTOListResponseDTO implements ICompanyDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CompanyDTO[] | undefined;

  constructor(data?: ICompanyDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(CompanyDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CompanyDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new CompanyDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICompanyDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CompanyDTO[] | undefined;
}

export class CompanyDTOObjectResponseDTO
  implements ICompanyDTOObjectResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CompanyDTO;

  constructor(data?: ICompanyDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? CompanyDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CompanyDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new CompanyDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICompanyDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CompanyDTO;
}

export class CompanyObjectResponseDTO implements ICompanyObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: Company;

  constructor(data?: ICompanyObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? Company.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CompanyObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new CompanyObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICompanyObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: Company;
}

export class CompanyUpdateSessionDTO implements ICompanyUpdateSessionDTO {
  errors?: { [key: string]: string[] } | undefined;
  id?: string;
  firmwareId?: string;
  succeeded?: boolean | undefined;
  startDate?: Date;
  updateResults?: UpdateResultDTO[] | undefined;
  company?: CompanyDTO;

  constructor(data?: ICompanyUpdateSessionDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.firmwareId = _data["firmwareId"];
      this.succeeded = _data["succeeded"];
      this.startDate = _data["startDate"]
        ? new Date(_data["startDate"].toString())
        : <any>undefined;
      if (Array.isArray(_data["updateResults"])) {
        this.updateResults = [] as any;
        for (let item of _data["updateResults"])
          this.updateResults!.push(UpdateResultDTO.fromJS(item));
      }
      this.company = _data["company"]
        ? CompanyDTO.fromJS(_data["company"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CompanyUpdateSessionDTO {
    data = typeof data === "object" ? data : {};
    let result = new CompanyUpdateSessionDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["firmwareId"] = this.firmwareId;
    data["succeeded"] = this.succeeded;
    data["startDate"] = this.startDate
      ? this.startDate.toISOString()
      : <any>undefined;
    if (Array.isArray(this.updateResults)) {
      data["updateResults"] = [];
      for (let item of this.updateResults)
        data["updateResults"].push(item.toJSON());
    }
    data["company"] = this.company ? this.company.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICompanyUpdateSessionDTO {
  errors?: { [key: string]: string[] } | undefined;
  id?: string;
  firmwareId?: string;
  succeeded?: boolean | undefined;
  startDate?: Date;
  updateResults?: UpdateResultDTO[] | undefined;
  company?: CompanyDTO;
}

/** Модель компании для начала обновления ПО */
export class CompanyVehicles implements ICompanyVehicles {
  /** Идентификатор компании */
  id!: string;
  /** Список уникальных идентификаторов транспортных средств, на которые будет происходить загрузка прошивки */
  uvIs?: string[] | undefined;

  constructor(data?: ICompanyVehicles) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      if (Array.isArray(_data["uvIs"])) {
        this.uvIs = [] as any;
        for (let item of _data["uvIs"]) this.uvIs!.push(item);
      }
    }
  }

  static fromJS(data: any): CompanyVehicles {
    data = typeof data === "object" ? data : {};
    let result = new CompanyVehicles();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    if (Array.isArray(this.uvIs)) {
      data["uvIs"] = [];
      for (let item of this.uvIs) data["uvIs"].push(item);
    }
    return data;
  }
}

/** Модель компании для начала обновления ПО */
export interface ICompanyVehicles {
  /** Идентификатор компании */
  id: string;
  /** Список уникальных идентификаторов транспортных средств, на которые будет происходить загрузка прошивки */
  uvIs?: string[] | undefined;
}

/** Координаты */
export class Coordinates implements ICoordinates {
  errors?: { [key: string]: string[] } | undefined;
  /** Долгота */
  longitude?: number | undefined;
  /** Широта */
  latitude?: number | undefined;

  constructor(data?: ICoordinates) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.longitude = _data["longitude"];
      this.latitude = _data["latitude"];
    }
  }

  static fromJS(data: any): Coordinates {
    data = typeof data === "object" ? data : {};
    let result = new Coordinates();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["longitude"] = this.longitude;
    data["latitude"] = this.latitude;
    return data;
  }
}

/** Координаты */
export interface ICoordinates {
  errors?: { [key: string]: string[] } | undefined;
  /** Долгота */
  longitude?: number | undefined;
  /** Широта */
  latitude?: number | undefined;
}

export class CoordinatesMessageDTO implements ICoordinatesMessageDTO {
  errors?: { [key: string]: string[] } | undefined;
  uvi?: string | undefined;
  coordinatesDTO?: Coordinates;
  engineHours?: number | undefined;
  messageDate?: Date | undefined;
  recordDate?: Date;
  number?: number;

  constructor(data?: ICoordinatesMessageDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.uvi = _data["uvi"];
      this.coordinatesDTO = _data["coordinatesDTO"]
        ? Coordinates.fromJS(_data["coordinatesDTO"])
        : <any>undefined;
      this.engineHours = _data["engineHours"];
      this.messageDate = _data["messageDate"]
        ? new Date(_data["messageDate"].toString())
        : <any>undefined;
      this.recordDate = _data["recordDate"]
        ? new Date(_data["recordDate"].toString())
        : <any>undefined;
      this.number = _data["number"];
    }
  }

  static fromJS(data: any): CoordinatesMessageDTO {
    data = typeof data === "object" ? data : {};
    let result = new CoordinatesMessageDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["uvi"] = this.uvi;
    data["coordinatesDTO"] = this.coordinatesDTO
      ? this.coordinatesDTO.toJSON()
      : <any>undefined;
    data["engineHours"] = this.engineHours;
    data["messageDate"] = this.messageDate
      ? this.messageDate.toISOString()
      : <any>undefined;
    data["recordDate"] = this.recordDate
      ? this.recordDate.toISOString()
      : <any>undefined;
    data["number"] = this.number;
    return data;
  }
}

export interface ICoordinatesMessageDTO {
  errors?: { [key: string]: string[] } | undefined;
  uvi?: string | undefined;
  coordinatesDTO?: Coordinates;
  engineHours?: number | undefined;
  messageDate?: Date | undefined;
  recordDate?: Date;
  number?: number;
}

export class CoordinatesMessageDTOListResponseDTO
  implements ICoordinatesMessageDTOListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CoordinatesMessageDTO[] | undefined;

  constructor(data?: ICoordinatesMessageDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(CoordinatesMessageDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CoordinatesMessageDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new CoordinatesMessageDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICoordinatesMessageDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CoordinatesMessageDTO[] | undefined;
}

export class CoordinatesMessageDTOObjectResponseDTO
  implements ICoordinatesMessageDTOObjectResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CoordinatesMessageDTO;

  constructor(data?: ICoordinatesMessageDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? CoordinatesMessageDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CoordinatesMessageDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new CoordinatesMessageDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICoordinatesMessageDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CoordinatesMessageDTO;
}

/** Параметр критерия */
export class CriterionParameter implements ICriterionParameter {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: number;
  /** Название (равно, больше и т.д.) */
  name?: string | undefined;
  /** Значение (==, > и т.д.) */
  value?: string | undefined;

  constructor(data?: ICriterionParameter) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.name = _data["name"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): CriterionParameter {
    data = typeof data === "object" ? data : {};
    let result = new CriterionParameter();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["name"] = this.name;
    data["value"] = this.value;
    return data;
  }
}

/** Параметр критерия */
export interface ICriterionParameter {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: number;
  /** Название (равно, больше и т.д.) */
  name?: string | undefined;
  /** Значение (==, > и т.д.) */
  value?: string | undefined;
}

export class CriterionParameterListResponseDTO
  implements ICriterionParameterListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CriterionParameter[] | undefined;

  constructor(data?: ICriterionParameterListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(CriterionParameter.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CriterionParameterListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new CriterionParameterListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICriterionParameterListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: CriterionParameter[] | undefined;
}

/** Порядок байтов */
export enum DataOrder {
  LH = 1,
  HL = 2,
}

/** Формат данных */
export enum DataSigned {
  Signed = 1,
  Unsigned = 2,
}

/** Тип данных */
export enum DataType {
  Bit = 1,
  Byte = 2,
  TwoByte = 3,
}

/** Модель для скачивания файла (DTO) */
export class DownloadFileDTO implements IDownloadFileDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Путь до файла */
  path?: string | undefined;

  constructor(data?: IDownloadFileDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.path = _data["path"];
    }
  }

  static fromJS(data: any): DownloadFileDTO {
    data = typeof data === "object" ? data : {};
    let result = new DownloadFileDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["path"] = this.path;
    return data;
  }
}

/** Модель для скачивания файла (DTO) */
export interface IDownloadFileDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Путь до файла */
  path?: string | undefined;
}

export class DownloadFileDTOObjectResponseDTO
  implements IDownloadFileDTOObjectResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: DownloadFileDTO;

  constructor(data?: IDownloadFileDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? DownloadFileDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): DownloadFileDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new DownloadFileDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IDownloadFileDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: DownloadFileDTO;
}

/** Сущность (таблица) */
export enum Entity {
  Vehicle = 1,
  Function = 2,
  FunctionGroup = 3,
  StatusCriteria = 4,
  User = 5,
}

/** Прошивка (сущность) */
export class Firmware implements IFirmware {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string | undefined;
  /** Название прошивки */
  name?: string | undefined;
  /** Название файла */
  fileName?: string | undefined;
  /** Версия */
  version?: string | undefined;
  /** Дата создания */
  creationDate?: Date;
  /** Список компаний, которые имеют доступ к прошивке (навигационное свойство) */
  companies?: Company[] | undefined;
  /** Сессии обновления ПО (навигационное свойство) */
  updateSessions?: UpdateSession[] | undefined;
  isNew?: boolean;

  constructor(data?: IFirmware) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.name = _data["name"];
      this.fileName = _data["fileName"];
      this.version = _data["version"];
      this.creationDate = _data["creationDate"]
        ? new Date(_data["creationDate"].toString())
        : <any>undefined;
      if (Array.isArray(_data["companies"])) {
        this.companies = [] as any;
        for (let item of _data["companies"])
          this.companies!.push(Company.fromJS(item));
      }
      if (Array.isArray(_data["updateSessions"])) {
        this.updateSessions = [] as any;
        for (let item of _data["updateSessions"])
          this.updateSessions!.push(UpdateSession.fromJS(item));
      }
      this.isNew = _data["isNew"];
    }
  }

  static fromJS(data: any): Firmware {
    data = typeof data === "object" ? data : {};
    let result = new Firmware();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["name"] = this.name;
    data["fileName"] = this.fileName;
    data["version"] = this.version;
    data["creationDate"] = this.creationDate
      ? this.creationDate.toISOString()
      : <any>undefined;
    if (Array.isArray(this.companies)) {
      data["companies"] = [];
      for (let item of this.companies) data["companies"].push(item.toJSON());
    }
    if (Array.isArray(this.updateSessions)) {
      data["updateSessions"] = [];
      for (let item of this.updateSessions)
        data["updateSessions"].push(item.toJSON());
    }
    data["isNew"] = this.isNew;
    return data;
  }
}

/** Прошивка (сущность) */
export interface IFirmware {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string | undefined;
  /** Название прошивки */
  name?: string | undefined;
  /** Название файла */
  fileName?: string | undefined;
  /** Версия */
  version?: string | undefined;
  /** Дата создания */
  creationDate?: Date;
  /** Список компаний, которые имеют доступ к прошивке (навигационное свойство) */
  companies?: Company[] | undefined;
  /** Сессии обновления ПО (навигационное свойство) */
  updateSessions?: UpdateSession[] | undefined;
  isNew?: boolean;
}

export class FirmwareListResponseDTO implements IFirmwareListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: Firmware[] | undefined;

  constructor(data?: IFirmwareListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"]) this.data!.push(Firmware.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FirmwareListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new FirmwareListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IFirmwareListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: Firmware[] | undefined;
}

export class FirmwareObjectResponseDTO implements IFirmwareObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: Firmware;

  constructor(data?: IFirmwareObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? Firmware.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): FirmwareObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new FirmwareObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IFirmwareObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: Firmware;
}

export enum Format {
  Standard = 1,
  Extended = 2,
}

/** Функция */
export class FunctionDTO implements IFunctionDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string | undefined;
  /** Уникальный идентификатор транспортного средства */
  uvi!: string;
  /** Идентификатор группы */
  groupId?: number;
  /** Название */
  name!: string;
  status?: FunctionStatus;
  /** Идентификатор сообщений can-шины */
  canId!: string;
  /** SPN */
  spn?: number | undefined;
  /** Описание/заметки */
  note?: string | undefined;
  dataType?: DataType;
  /** Номер байта */
  dataByte?: number;
  /** Номер бита */
  dataBit?: number | undefined;
  dataOrder?: DataOrder;
  dataSigned?: DataSigned;
  /** Результат функции в формате DEC */
  result?: number | undefined;
  /** Результат функции в формате HEX */
  hexResult?: string | undefined;
  /** Дата */
  date?: Date;
  /** Список критериев для статусов */
  statusCriteria?: StatusCriterionDTO[] | undefined;

  constructor(data?: IFunctionDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.uvi = _data["uvi"];
      this.groupId = _data["groupId"];
      this.name = _data["name"];
      this.status = _data["status"]
        ? FunctionStatus.fromJS(_data["status"])
        : <any>undefined;
      this.canId = _data["canId"];
      this.spn = _data["spn"];
      this.note = _data["note"];
      this.dataType = _data["dataType"];
      this.dataByte = _data["dataByte"];
      this.dataBit = _data["dataBit"];
      this.dataOrder = _data["dataOrder"];
      this.dataSigned = _data["dataSigned"];
      this.result = _data["result"];
      this.hexResult = _data["hexResult"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
      if (Array.isArray(_data["statusCriteria"])) {
        this.statusCriteria = [] as any;
        for (let item of _data["statusCriteria"])
          this.statusCriteria!.push(StatusCriterionDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FunctionDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["uvi"] = this.uvi;
    data["groupId"] = this.groupId;
    data["name"] = this.name;
    data["status"] = this.status ? this.status.toJSON() : <any>undefined;
    data["canId"] = this.canId;
    data["spn"] = this.spn;
    data["note"] = this.note;
    data["dataType"] = this.dataType;
    data["dataByte"] = this.dataByte;
    data["dataBit"] = this.dataBit;
    data["dataOrder"] = this.dataOrder;
    data["dataSigned"] = this.dataSigned;
    data["result"] = this.result;
    data["hexResult"] = this.hexResult;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    if (Array.isArray(this.statusCriteria)) {
      data["statusCriteria"] = [];
      for (let item of this.statusCriteria)
        data["statusCriteria"].push(item.toJSON());
    }
    return data;
  }
}

/** Функция */
export interface IFunctionDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string | undefined;
  /** Уникальный идентификатор транспортного средства */
  uvi: string;
  /** Идентификатор группы */
  groupId?: number;
  /** Название */
  name: string;
  status?: FunctionStatus;
  /** Идентификатор сообщений can-шины */
  canId: string;
  /** SPN */
  spn?: number | undefined;
  /** Описание/заметки */
  note?: string | undefined;
  dataType?: DataType;
  /** Номер байта */
  dataByte?: number;
  /** Номер бита */
  dataBit?: number | undefined;
  dataOrder?: DataOrder;
  dataSigned?: DataSigned;
  /** Результат функции в формате DEC */
  result?: number | undefined;
  /** Результат функции в формате HEX */
  hexResult?: string | undefined;
  /** Дата */
  date?: Date;
  /** Список критериев для статусов */
  statusCriteria?: StatusCriterionDTO[] | undefined;
}

/** Действие пользователя (история действий) */
export class FunctionDTOActionHistoryDTO
  implements IFunctionDTOActionHistoryDTO
{
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** IP-пользователя */
  ip?: string | undefined;
  actionType?: ActionType;
  /** Дата */
  date?: Date;
  data?: FunctionDTO;

  constructor(data?: IFunctionDTOActionHistoryDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.ip = _data["ip"];
      this.actionType = _data["actionType"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
      this.data = _data["data"]
        ? FunctionDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): FunctionDTOActionHistoryDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionDTOActionHistoryDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["ip"] = this.ip;
    data["actionType"] = this.actionType;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

/** Действие пользователя (история действий) */
export interface IFunctionDTOActionHistoryDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** IP-пользователя */
  ip?: string | undefined;
  actionType?: ActionType;
  /** Дата */
  date?: Date;
  data?: FunctionDTO;
}

export class FunctionDTOActionHistoryDTOListResponseDTO
  implements IFunctionDTOActionHistoryDTOListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionDTOActionHistoryDTO[] | undefined;

  constructor(data?: IFunctionDTOActionHistoryDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(FunctionDTOActionHistoryDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FunctionDTOActionHistoryDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionDTOActionHistoryDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IFunctionDTOActionHistoryDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionDTOActionHistoryDTO[] | undefined;
}

export class FunctionDTOListResponseDTO implements IFunctionDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionDTO[] | undefined;

  constructor(data?: IFunctionDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(FunctionDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FunctionDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IFunctionDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionDTO[] | undefined;
}

export class FunctionDTOObjectResponseDTO
  implements IFunctionDTOObjectResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionDTO;

  constructor(data?: IFunctionDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? FunctionDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): FunctionDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IFunctionDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionDTO;
}

/** Группа функции */
export class FunctionGroup implements IFunctionGroup {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: number;
  /** Название группы */
  groupName!: string;

  constructor(data?: IFunctionGroup) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.groupName = _data["groupName"];
    }
  }

  static fromJS(data: any): FunctionGroup {
    data = typeof data === "object" ? data : {};
    let result = new FunctionGroup();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["groupName"] = this.groupName;
    return data;
  }
}

/** Группа функции */
export interface IFunctionGroup {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: number;
  /** Название группы */
  groupName: string;
}

/** Действие пользователя (история действий) */
export class FunctionGroupActionHistoryDTO
  implements IFunctionGroupActionHistoryDTO
{
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** IP-пользователя */
  ip?: string | undefined;
  actionType?: ActionType;
  /** Дата */
  date?: Date;
  data?: FunctionGroup;

  constructor(data?: IFunctionGroupActionHistoryDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.ip = _data["ip"];
      this.actionType = _data["actionType"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
      this.data = _data["data"]
        ? FunctionGroup.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): FunctionGroupActionHistoryDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionGroupActionHistoryDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["ip"] = this.ip;
    data["actionType"] = this.actionType;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

/** Действие пользователя (история действий) */
export interface IFunctionGroupActionHistoryDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** IP-пользователя */
  ip?: string | undefined;
  actionType?: ActionType;
  /** Дата */
  date?: Date;
  data?: FunctionGroup;
}

export class FunctionGroupActionHistoryDTOListResponseDTO
  implements IFunctionGroupActionHistoryDTOListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionGroupActionHistoryDTO[] | undefined;

  constructor(data?: IFunctionGroupActionHistoryDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(FunctionGroupActionHistoryDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FunctionGroupActionHistoryDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionGroupActionHistoryDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IFunctionGroupActionHistoryDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionGroupActionHistoryDTO[] | undefined;
}

export class FunctionGroupListResponseDTO
  implements IFunctionGroupListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionGroup[] | undefined;

  constructor(data?: IFunctionGroupListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(FunctionGroup.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FunctionGroupListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionGroupListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IFunctionGroupListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionGroup[] | undefined;
}

export class FunctionGroupObjectResponseDTO
  implements IFunctionGroupObjectResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionGroup;

  constructor(data?: IFunctionGroupObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? FunctionGroup.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): FunctionGroupObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionGroupObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IFunctionGroupObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionGroup;
}

export class FunctionHistoryDTO implements IFunctionHistoryDTO {
  errors?: { [key: string]: string[] } | undefined;
  function?: FunctionDTO;
  results?: FunctionResultDTO[] | undefined;

  constructor(data?: IFunctionHistoryDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.function = _data["function"]
        ? FunctionDTO.fromJS(_data["function"])
        : <any>undefined;
      if (Array.isArray(_data["results"])) {
        this.results = [] as any;
        for (let item of _data["results"])
          this.results!.push(FunctionResultDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FunctionHistoryDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionHistoryDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["function"] = this.function ? this.function.toJSON() : <any>undefined;
    if (Array.isArray(this.results)) {
      data["results"] = [];
      for (let item of this.results) data["results"].push(item.toJSON());
    }
    return data;
  }
}

export interface IFunctionHistoryDTO {
  errors?: { [key: string]: string[] } | undefined;
  function?: FunctionDTO;
  results?: FunctionResultDTO[] | undefined;
}

export class FunctionHistoryDTOObjectResponseDTO
  implements IFunctionHistoryDTOObjectResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionHistoryDTO;

  constructor(data?: IFunctionHistoryDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? FunctionHistoryDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): FunctionHistoryDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionHistoryDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IFunctionHistoryDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionHistoryDTO;
}

export class FunctionResultDTO implements IFunctionResultDTO {
  result?: number | undefined;
  hexResult?: string | undefined;
  status?: FunctionStatus;
  date?: Date | undefined;

  constructor(data?: IFunctionResultDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.hexResult = _data["hexResult"];
      this.status = _data["status"]
        ? FunctionStatus.fromJS(_data["status"])
        : <any>undefined;
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): FunctionResultDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionResultDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["result"] = this.result;
    data["hexResult"] = this.hexResult;
    data["status"] = this.status ? this.status.toJSON() : <any>undefined;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

export interface IFunctionResultDTO {
  result?: number | undefined;
  hexResult?: string | undefined;
  status?: FunctionStatus;
  date?: Date | undefined;
}

/** Статус функции */
export class FunctionStatus implements IFunctionStatus {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: number;
  /** Название статуса */
  name?: string | undefined;

  constructor(data?: IFunctionStatus) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): FunctionStatus {
    data = typeof data === "object" ? data : {};
    let result = new FunctionStatus();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

/** Статус функции */
export interface IFunctionStatus {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: number;
  /** Название статуса */
  name?: string | undefined;
}

export class FunctionStatusListResponseDTO
  implements IFunctionStatusListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionStatus[] | undefined;

  constructor(data?: IFunctionStatusListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(FunctionStatus.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FunctionStatusListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new FunctionStatusListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IFunctionStatusListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: FunctionStatus[] | undefined;
}

/** Пол пользователя */
export enum Gender {
  Male = 0,
  Female = 1,
}

export class J1939ParametersDTO implements IJ1939ParametersDTO {
  errors?: { [key: string]: string[] } | undefined;
  id?: string | undefined;
  pgn?: number;
  spn?: number;
  parameterGroupLabel?: string | undefined;
  name?: string | undefined;
  dataStart?: number;
  dataLenght?: number;
  resolution?: number;
  offset?: number;
  resoliutionUnit?: string | undefined;
  dataRangeMin?: number;
  dataRangeMax?: number;
  unit?: string | undefined;
  description?: string | undefined;

  constructor(data?: IJ1939ParametersDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.pgn = _data["pgn"];
      this.spn = _data["spn"];
      this.parameterGroupLabel = _data["parameterGroupLabel"];
      this.name = _data["name"];
      this.dataStart = _data["dataStart"];
      this.dataLenght = _data["dataLenght"];
      this.resolution = _data["resolution"];
      this.offset = _data["offset"];
      this.resoliutionUnit = _data["resoliutionUnit"];
      this.dataRangeMin = _data["dataRangeMin"];
      this.dataRangeMax = _data["dataRangeMax"];
      this.unit = _data["unit"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): J1939ParametersDTO {
    data = typeof data === "object" ? data : {};
    let result = new J1939ParametersDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["pgn"] = this.pgn;
    data["spn"] = this.spn;
    data["parameterGroupLabel"] = this.parameterGroupLabel;
    data["name"] = this.name;
    data["dataStart"] = this.dataStart;
    data["dataLenght"] = this.dataLenght;
    data["resolution"] = this.resolution;
    data["offset"] = this.offset;
    data["resoliutionUnit"] = this.resoliutionUnit;
    data["dataRangeMin"] = this.dataRangeMin;
    data["dataRangeMax"] = this.dataRangeMax;
    data["unit"] = this.unit;
    data["description"] = this.description;
    return data;
  }
}

export interface IJ1939ParametersDTO {
  errors?: { [key: string]: string[] } | undefined;
  id?: string | undefined;
  pgn?: number;
  spn?: number;
  parameterGroupLabel?: string | undefined;
  name?: string | undefined;
  dataStart?: number;
  dataLenght?: number;
  resolution?: number;
  offset?: number;
  resoliutionUnit?: string | undefined;
  dataRangeMin?: number;
  dataRangeMax?: number;
  unit?: string | undefined;
  description?: string | undefined;
}

export class J1939ParametersDTOListResponseDTO
  implements IJ1939ParametersDTOListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: J1939ParametersDTO[] | undefined;

  constructor(data?: IJ1939ParametersDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(J1939ParametersDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): J1939ParametersDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new J1939ParametersDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IJ1939ParametersDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: J1939ParametersDTO[] | undefined;
}

export class J1939ParametersDTOObjectResponseDTO
  implements IJ1939ParametersDTOObjectResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: J1939ParametersDTO;

  constructor(data?: IJ1939ParametersDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? J1939ParametersDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): J1939ParametersDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new J1939ParametersDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IJ1939ParametersDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: J1939ParametersDTO;
}

export class LoginBrokerDTO implements ILoginBrokerDTO {
  /** Имя пользователя */
  userName!: string;
  /** Пароль */
  password!: string;
  companyId!: string;

  constructor(data?: ILoginBrokerDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data["userName"];
      this.password = _data["password"];
      this.companyId = _data["companyId"];
    }
  }

  static fromJS(data: any): LoginBrokerDTO {
    data = typeof data === "object" ? data : {};
    let result = new LoginBrokerDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userName"] = this.userName;
    data["password"] = this.password;
    data["companyId"] = this.companyId;
    return data;
  }
}

export interface ILoginBrokerDTO {
  /** Имя пользователя */
  userName: string;
  /** Пароль */
  password: string;
  companyId: string;
}

export class LoginResponseDTO implements ILoginResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  tokens?: TokensDTO;
  isEmailConfirmed?: boolean | undefined;
  role?: string[] | undefined;
  companyId?: string | undefined;

  constructor(data?: ILoginResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.tokens = _data["tokens"]
        ? TokensDTO.fromJS(_data["tokens"])
        : <any>undefined;
      this.isEmailConfirmed = _data["isEmailConfirmed"];
      if (Array.isArray(_data["role"])) {
        this.role = [] as any;
        for (let item of _data["role"]) this.role!.push(item);
      }
      this.companyId = _data["companyId"];
    }
  }

  static fromJS(data: any): LoginResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new LoginResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["tokens"] = this.tokens ? this.tokens.toJSON() : <any>undefined;
    data["isEmailConfirmed"] = this.isEmailConfirmed;
    if (Array.isArray(this.role)) {
      data["role"] = [];
      for (let item of this.role) data["role"].push(item);
    }
    data["companyId"] = this.companyId;
    return data;
  }
}

export interface ILoginResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  tokens?: TokensDTO;
  isEmailConfirmed?: boolean | undefined;
  role?: string[] | undefined;
  companyId?: string | undefined;
}

export class ModuleConnectionDTO implements IModuleConnectionDTO {
  errors?: { [key: string]: string[] } | undefined;
  id?: string;
  uvi?: string | undefined;
  connected?: boolean;
  expected?: boolean;
  date?: Date;

  constructor(data?: IModuleConnectionDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.uvi = _data["uvi"];
      this.connected = _data["connected"];
      this.expected = _data["expected"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): ModuleConnectionDTO {
    data = typeof data === "object" ? data : {};
    let result = new ModuleConnectionDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["uvi"] = this.uvi;
    data["connected"] = this.connected;
    data["expected"] = this.expected;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

export interface IModuleConnectionDTO {
  errors?: { [key: string]: string[] } | undefined;
  id?: string;
  uvi?: string | undefined;
  connected?: boolean;
  expected?: boolean;
  date?: Date;
}

export class ModuleConnectionDTOListResponseDTO
  implements IModuleConnectionDTOListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: ModuleConnectionDTO[] | undefined;

  constructor(data?: IModuleConnectionDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(ModuleConnectionDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ModuleConnectionDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new ModuleConnectionDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IModuleConnectionDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: ModuleConnectionDTO[] | undefined;
}

export class ModuleDTO implements IModuleDTO {
  errors?: { [key: string]: string[] } | undefined;
  uvi?: string | undefined;
  /** Imei модуля */
  imei?: string | undefined;
  sim?: SIM;
  canInterfaceSpeed?: number;
  logSize?: number;
  coordinatesPeriod?: number;
  firmware?: string | undefined;
  isConnected?: boolean;
  settingsConfirmed?: boolean;
  connectionSettingsConfirmed?: boolean;
  companyId?: string | undefined;
  /** Описание/заметки */
  notes?: string | undefined;

  constructor(data?: IModuleDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.uvi = _data["uvi"];
      this.imei = _data["imei"];
      this.sim = _data["sim"] ? SIM.fromJS(_data["sim"]) : <any>undefined;
      this.canInterfaceSpeed = _data["canInterfaceSpeed"];
      this.logSize = _data["logSize"];
      this.coordinatesPeriod = _data["coordinatesPeriod"];
      this.firmware = _data["firmware"];
      this.isConnected = _data["isConnected"];
      this.settingsConfirmed = _data["settingsConfirmed"];
      this.connectionSettingsConfirmed = _data["connectionSettingsConfirmed"];
      this.companyId = _data["companyId"];
      this.notes = _data["notes"];
    }
  }

  static fromJS(data: any): ModuleDTO {
    data = typeof data === "object" ? data : {};
    let result = new ModuleDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["uvi"] = this.uvi;
    data["imei"] = this.imei;
    data["sim"] = this.sim ? this.sim.toJSON() : <any>undefined;
    data["canInterfaceSpeed"] = this.canInterfaceSpeed;
    data["logSize"] = this.logSize;
    data["coordinatesPeriod"] = this.coordinatesPeriod;
    data["firmware"] = this.firmware;
    data["isConnected"] = this.isConnected;
    data["settingsConfirmed"] = this.settingsConfirmed;
    data["connectionSettingsConfirmed"] = this.connectionSettingsConfirmed;
    data["companyId"] = this.companyId;
    data["notes"] = this.notes;
    return data;
  }
}

export interface IModuleDTO {
  errors?: { [key: string]: string[] } | undefined;
  uvi?: string | undefined;
  /** Imei модуля */
  imei?: string | undefined;
  sim?: SIM;
  canInterfaceSpeed?: number;
  logSize?: number;
  coordinatesPeriod?: number;
  firmware?: string | undefined;
  isConnected?: boolean;
  settingsConfirmed?: boolean;
  connectionSettingsConfirmed?: boolean;
  companyId?: string | undefined;
  /** Описание/заметки */
  notes?: string | undefined;
}

export class ModuleDTOListResponseDTO implements IModuleDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: ModuleDTO[] | undefined;

  constructor(data?: IModuleDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"]) this.data!.push(ModuleDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ModuleDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new ModuleDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IModuleDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: ModuleDTO[] | undefined;
}

export class ModuleDTOObjectResponseDTO implements IModuleDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: ModuleDTO;

  constructor(data?: IModuleDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? ModuleDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ModuleDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new ModuleDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IModuleDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: ModuleDTO;
}

export class ModuleFirmwareDTO implements IModuleFirmwareDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор прошивки */
  firmwareId?: string | undefined;
  /** Название прошивки */
  name?: string | undefined;
  /** Название файла */
  fileName?: string | undefined;
  /** Версия */
  version?: string | undefined;
  /** Дата завершения сессии обновления ПО */
  date?: Date;

  constructor(data?: IModuleFirmwareDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.firmwareId = _data["firmwareId"];
      this.name = _data["name"];
      this.fileName = _data["fileName"];
      this.version = _data["version"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): ModuleFirmwareDTO {
    data = typeof data === "object" ? data : {};
    let result = new ModuleFirmwareDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["firmwareId"] = this.firmwareId;
    data["name"] = this.name;
    data["fileName"] = this.fileName;
    data["version"] = this.version;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

export interface IModuleFirmwareDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор прошивки */
  firmwareId?: string | undefined;
  /** Название прошивки */
  name?: string | undefined;
  /** Название файла */
  fileName?: string | undefined;
  /** Версия */
  version?: string | undefined;
  /** Дата завершения сессии обновления ПО */
  date?: Date;
}

export class ModuleFirmwareDTOObjectResponseDTO
  implements IModuleFirmwareDTOObjectResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: ModuleFirmwareDTO;

  constructor(data?: IModuleFirmwareDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? ModuleFirmwareDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ModuleFirmwareDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new ModuleFirmwareDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IModuleFirmwareDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: ModuleFirmwareDTO;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export enum Protocol {
  Standard = 1,
  J1939 = 2,
}

/** Модель для предоставления доступа к прошивке */
export class ProvideAccessToFirmwareDTO implements IProvideAccessToFirmwareDTO {
  /** Идентификатор прошивки */
  firmwareId!: string;
  /** Идентификаторы компаний */
  companiesId!: string[];

  constructor(data?: IProvideAccessToFirmwareDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.companiesId = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firmwareId = _data["firmwareId"];
      if (Array.isArray(_data["companiesId"])) {
        this.companiesId = [] as any;
        for (let item of _data["companiesId"]) this.companiesId!.push(item);
      }
    }
  }

  static fromJS(data: any): ProvideAccessToFirmwareDTO {
    data = typeof data === "object" ? data : {};
    let result = new ProvideAccessToFirmwareDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firmwareId"] = this.firmwareId;
    if (Array.isArray(this.companiesId)) {
      data["companiesId"] = [];
      for (let item of this.companiesId) data["companiesId"].push(item);
    }
    return data;
  }
}

/** Модель для предоставления доступа к прошивке */
export interface IProvideAccessToFirmwareDTO {
  /** Идентификатор прошивки */
  firmwareId: string;
  /** Идентификаторы компаний */
  companiesId: string[];
}

/** Модель для сброса пароля */
export class ResetPasswordDTO implements IResetPasswordDTO {
  /** Новый пароль */
  password!: string;
  /** Электронная почта */
  email!: string;
  /** Токен сброса пароля */
  resetToken!: string;

  constructor(data?: IResetPasswordDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.password = _data["password"];
      this.email = _data["email"];
      this.resetToken = _data["resetToken"];
    }
  }

  static fromJS(data: any): ResetPasswordDTO {
    data = typeof data === "object" ? data : {};
    let result = new ResetPasswordDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["password"] = this.password;
    data["email"] = this.email;
    data["resetToken"] = this.resetToken;
    return data;
  }
}

/** Модель для сброса пароля */
export interface IResetPasswordDTO {
  /** Новый пароль */
  password: string;
  /** Электронная почта */
  email: string;
  /** Токен сброса пароля */
  resetToken: string;
}

/** Модель для отправки письма на электронную почту для сброса пароля */
export class ResetPasswordEmail implements IResetPasswordEmail {
  /** Электронная почта */
  email!: string;

  constructor(data?: IResetPasswordEmail) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
    }
  }

  static fromJS(data: any): ResetPasswordEmail {
    data = typeof data === "object" ? data : {};
    let result = new ResetPasswordEmail();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["email"] = this.email;
    return data;
  }
}

/** Модель для отправки письма на электронную почту для сброса пароля */
export interface IResetPasswordEmail {
  /** Электронная почта */
  email: string;
}

export class ResetPasswordResponseDTO implements IResetPasswordResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  isEmailConfirmed?: boolean | undefined;

  constructor(data?: IResetPasswordResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.isEmailConfirmed = _data["isEmailConfirmed"];
    }
  }

  static fromJS(data: any): ResetPasswordResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new ResetPasswordResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["isEmailConfirmed"] = this.isEmailConfirmed;
    return data;
  }
}

export interface IResetPasswordResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  isEmailConfirmed?: boolean | undefined;
}

export class ResponseDTO implements IResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;

  constructor(data?: IResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): ResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new ResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    return data;
  }
}

export interface IResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
}

export enum Roaming {
  Prohibited = 1,
  OnlyForSMS = 2,
  Allowed = 3,
}

/** Роль пользователя */
export class RoleDTO implements IRoleDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор роли */
  id?: string | undefined;
  /** Название роли */
  name?: string | undefined;

  constructor(data?: IRoleDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): RoleDTO {
    data = typeof data === "object" ? data : {};
    let result = new RoleDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

/** Роль пользователя */
export interface IRoleDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор роли */
  id?: string | undefined;
  /** Название роли */
  name?: string | undefined;
}

export class RoleDTOListResponseDTO implements IRoleDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: RoleDTO[] | undefined;

  constructor(data?: IRoleDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"]) this.data!.push(RoleDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RoleDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new RoleDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IRoleDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: RoleDTO[] | undefined;
}

export class RoleDTOObjectResponseDTO implements IRoleDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: RoleDTO;

  constructor(data?: IRoleDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? RoleDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): RoleDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new RoleDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IRoleDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: RoleDTO;
}

export class SIM implements ISIM {
  /** Номер сим-карты */
  phoneNumber?: string | undefined;
  /** Пин-код */
  pin?: string | undefined;
  apn?: string | undefined;
  userName?: string | undefined;
  password?: string | undefined;
  roaming?: Roaming;

  constructor(data?: ISIM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.phoneNumber = _data["phoneNumber"];
      this.pin = _data["pin"];
      this.apn = _data["apn"];
      this.userName = _data["userName"];
      this.password = _data["password"];
      this.roaming = _data["roaming"];
    }
  }

  static fromJS(data: any): SIM {
    data = typeof data === "object" ? data : {};
    let result = new SIM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["phoneNumber"] = this.phoneNumber;
    data["pin"] = this.pin;
    data["apn"] = this.apn;
    data["userName"] = this.userName;
    data["password"] = this.password;
    data["roaming"] = this.roaming;
    return data;
  }
}

export interface ISIM {
  /** Номер сим-карты */
  phoneNumber?: string | undefined;
  /** Пин-код */
  pin?: string | undefined;
  apn?: string | undefined;
  userName?: string | undefined;
  password?: string | undefined;
  roaming?: Roaming;
}

/** Модель для начала сессии обновления ПО (для компании пользователя) */
export class StartCompanyUpdateSessionDTO
  implements IStartCompanyUpdateSessionDTO
{
  /** Идентификатор прошивки */
  firmwareId!: string;
  /** Список уникальных идентификаторов транспортных средств, на которые будет происходить загрузка прошивки */
  uvIs?: string[] | undefined;
  /** Игнорировать уже обновленные с помощью данной прошивки транспортные средства или нет */
  ignoreUpdated?: boolean;

  constructor(data?: IStartCompanyUpdateSessionDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firmwareId = _data["firmwareId"];
      if (Array.isArray(_data["uvIs"])) {
        this.uvIs = [] as any;
        for (let item of _data["uvIs"]) this.uvIs!.push(item);
      }
      this.ignoreUpdated = _data["ignoreUpdated"];
    }
  }

  static fromJS(data: any): StartCompanyUpdateSessionDTO {
    data = typeof data === "object" ? data : {};
    let result = new StartCompanyUpdateSessionDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firmwareId"] = this.firmwareId;
    if (Array.isArray(this.uvIs)) {
      data["uvIs"] = [];
      for (let item of this.uvIs) data["uvIs"].push(item);
    }
    data["ignoreUpdated"] = this.ignoreUpdated;
    return data;
  }
}

/** Модель для начала сессии обновления ПО (для компании пользователя) */
export interface IStartCompanyUpdateSessionDTO {
  /** Идентификатор прошивки */
  firmwareId: string;
  /** Список уникальных идентификаторов транспортных средств, на которые будет происходить загрузка прошивки */
  uvIs?: string[] | undefined;
  /** Игнорировать уже обновленные с помощью данной прошивки транспортные средства или нет */
  ignoreUpdated?: boolean;
}

/** Модель для начала сессии обновления ПО (для нескольких компаний) */
export class StartUpdateSessionDTO implements IStartUpdateSessionDTO {
  /** Идентификатор прошивки */
  firmwareId!: string;
  /** Список компаний, для которых будет происходить обновление ПО */
  companies?: CompanyVehicles[] | undefined;
  /** Игнорировать уже обновленные с помощью данной прошивки транспортные средства или нет */
  ignoreUpdated?: boolean;

  constructor(data?: IStartUpdateSessionDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firmwareId = _data["firmwareId"];
      if (Array.isArray(_data["companies"])) {
        this.companies = [] as any;
        for (let item of _data["companies"])
          this.companies!.push(CompanyVehicles.fromJS(item));
      }
      this.ignoreUpdated = _data["ignoreUpdated"];
    }
  }

  static fromJS(data: any): StartUpdateSessionDTO {
    data = typeof data === "object" ? data : {};
    let result = new StartUpdateSessionDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firmwareId"] = this.firmwareId;
    if (Array.isArray(this.companies)) {
      data["companies"] = [];
      for (let item of this.companies) data["companies"].push(item.toJSON());
    }
    data["ignoreUpdated"] = this.ignoreUpdated;
    return data;
  }
}

/** Модель для начала сессии обновления ПО (для нескольких компаний) */
export interface IStartUpdateSessionDTO {
  /** Идентификатор прошивки */
  firmwareId: string;
  /** Список компаний, для которых будет происходить обновление ПО */
  companies?: CompanyVehicles[] | undefined;
  /** Игнорировать уже обновленные с помощью данной прошивки транспортные средства или нет */
  ignoreUpdated?: boolean;
}

/** Результат начала сессии обновления ПО */
export class StartUpdateSessionResultDTO
  implements IStartUpdateSessionResultDTO
{
  errors?: { [key: string]: string[] } | undefined;
  result?: ResponseDTO;
  company?: CompanyDTO;

  constructor(data?: IStartUpdateSessionResultDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.result = _data["result"]
        ? ResponseDTO.fromJS(_data["result"])
        : <any>undefined;
      this.company = _data["company"]
        ? CompanyDTO.fromJS(_data["company"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): StartUpdateSessionResultDTO {
    data = typeof data === "object" ? data : {};
    let result = new StartUpdateSessionResultDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["company"] = this.company ? this.company.toJSON() : <any>undefined;
    return data;
  }
}

/** Результат начала сессии обновления ПО */
export interface IStartUpdateSessionResultDTO {
  errors?: { [key: string]: string[] } | undefined;
  result?: ResponseDTO;
  company?: CompanyDTO;
}

export class StartUpdateSessionResultDTOListResponseDTO
  implements IStartUpdateSessionResultDTOListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: StartUpdateSessionResultDTO[] | undefined;

  constructor(data?: IStartUpdateSessionResultDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(StartUpdateSessionResultDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): StartUpdateSessionResultDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new StartUpdateSessionResultDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IStartUpdateSessionResultDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: StartUpdateSessionResultDTO[] | undefined;
}

/** Критерий статуса */
export class StatusCriterionDTO implements IStatusCriterionDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string | undefined;
  /** Уникальный идентификатор транспортного средства */
  uvi!: string;
  /** Идентификатор функции */
  functionId!: string;
  /** Идентификатор параметра */
  parameterId!: number;
  /** Идентификатор статуса */
  statusId!: number;
  /** Значение критерия, с которым будет сравниваться результат функции */
  value!: number;

  constructor(data?: IStatusCriterionDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.uvi = _data["uvi"];
      this.functionId = _data["functionId"];
      this.parameterId = _data["parameterId"];
      this.statusId = _data["statusId"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): StatusCriterionDTO {
    data = typeof data === "object" ? data : {};
    let result = new StatusCriterionDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["uvi"] = this.uvi;
    data["functionId"] = this.functionId;
    data["parameterId"] = this.parameterId;
    data["statusId"] = this.statusId;
    data["value"] = this.value;
    return data;
  }
}

/** Критерий статуса */
export interface IStatusCriterionDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string | undefined;
  /** Уникальный идентификатор транспортного средства */
  uvi: string;
  /** Идентификатор функции */
  functionId: string;
  /** Идентификатор параметра */
  parameterId: number;
  /** Идентификатор статуса */
  statusId: number;
  /** Значение критерия, с которым будет сравниваться результат функции */
  value: number;
}

export class StatusCriterionDTOListResponseDTO
  implements IStatusCriterionDTOListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: StatusCriterionDTO[] | undefined;

  constructor(data?: IStatusCriterionDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(StatusCriterionDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): StatusCriterionDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new StatusCriterionDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IStatusCriterionDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: StatusCriterionDTO[] | undefined;
}

export class TokenModel implements ITokenModel {
  token!: string;
  expiration?: Date;

  constructor(data?: ITokenModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data["token"];
      this.expiration = _data["expiration"]
        ? new Date(_data["expiration"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): TokenModel {
    data = typeof data === "object" ? data : {};
    let result = new TokenModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["token"] = this.token;
    data["expiration"] = this.expiration
      ? this.expiration.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface ITokenModel {
  token: string;
  expiration?: Date;
}

export class TokensDTO implements ITokensDTO {
  accessToken!: TokenModel;
  refreshToken!: TokenModel;

  constructor(data?: ITokensDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.accessToken = new TokenModel();
      this.refreshToken = new TokenModel();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data["accessToken"]
        ? TokenModel.fromJS(_data["accessToken"])
        : new TokenModel();
      this.refreshToken = _data["refreshToken"]
        ? TokenModel.fromJS(_data["refreshToken"])
        : new TokenModel();
    }
  }

  static fromJS(data: any): TokensDTO {
    data = typeof data === "object" ? data : {};
    let result = new TokensDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["accessToken"] = this.accessToken
      ? this.accessToken.toJSON()
      : <any>undefined;
    data["refreshToken"] = this.refreshToken
      ? this.refreshToken.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface ITokensDTO {
  accessToken: TokenModel;
  refreshToken: TokenModel;
}

export class UpdateResultDTO implements IUpdateResultDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Название транспортного средства */
  name?: string | undefined;
  /** Уникальный идентификатор транспортного средства */
  uvi?: string | undefined;
  /** Id последней сессии */
  sessionId?: string;
  /** Id прошивки из последней сессии */
  firmwareId?: string | undefined;
  /** Id последней успешно загруженной прошивки */
  uploadedFirmwareId?: string | undefined;
  /** Дата начала последней сессии */
  startDate?: Date | undefined;
  /** Дата конца последней сессии */
  endDate?: Date | undefined;
  /** Успешно или нет завершилась последняя сессия */
  succeeded?: boolean | undefined;
  /** Код ошибки */
  error?: number | undefined;
  /** Название группы в хабе (SignalR) */
  hubGroup?: string | undefined;
  status?: UploadStatus;

  constructor(data?: IUpdateResultDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.name = _data["name"];
      this.uvi = _data["uvi"];
      this.sessionId = _data["sessionId"];
      this.firmwareId = _data["firmwareId"];
      this.uploadedFirmwareId = _data["uploadedFirmwareId"];
      this.startDate = _data["startDate"]
        ? new Date(_data["startDate"].toString())
        : <any>undefined;
      this.endDate = _data["endDate"]
        ? new Date(_data["endDate"].toString())
        : <any>undefined;
      this.succeeded = _data["succeeded"];
      this.error = _data["error"];
      this.hubGroup = _data["hubGroup"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): UpdateResultDTO {
    data = typeof data === "object" ? data : {};
    let result = new UpdateResultDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["name"] = this.name;
    data["uvi"] = this.uvi;
    data["sessionId"] = this.sessionId;
    data["firmwareId"] = this.firmwareId;
    data["uploadedFirmwareId"] = this.uploadedFirmwareId;
    data["startDate"] = this.startDate
      ? this.startDate.toISOString()
      : <any>undefined;
    data["endDate"] = this.endDate
      ? this.endDate.toISOString()
      : <any>undefined;
    data["succeeded"] = this.succeeded;
    data["error"] = this.error;
    data["hubGroup"] = this.hubGroup;
    data["status"] = this.status;
    return data;
  }
}

export interface IUpdateResultDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Название транспортного средства */
  name?: string | undefined;
  /** Уникальный идентификатор транспортного средства */
  uvi?: string | undefined;
  /** Id последней сессии */
  sessionId?: string;
  /** Id прошивки из последней сессии */
  firmwareId?: string | undefined;
  /** Id последней успешно загруженной прошивки */
  uploadedFirmwareId?: string | undefined;
  /** Дата начала последней сессии */
  startDate?: Date | undefined;
  /** Дата конца последней сессии */
  endDate?: Date | undefined;
  /** Успешно или нет завершилась последняя сессия */
  succeeded?: boolean | undefined;
  /** Код ошибки */
  error?: number | undefined;
  /** Название группы в хабе (SignalR) */
  hubGroup?: string | undefined;
  status?: UploadStatus;
}

export class UpdateResultDTOListResponseDTO
  implements IUpdateResultDTOListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: UpdateResultDTO[] | undefined;

  constructor(data?: IUpdateResultDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(UpdateResultDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdateResultDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new UpdateResultDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IUpdateResultDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: UpdateResultDTO[] | undefined;
}

export class UpdateSession implements IUpdateSession {
  id?: string;
  firmwareId?: string;
  firmware?: Firmware;
  succeeded?: boolean | undefined;
  startDate?: Date;
  endDate?: Date | undefined;
  companies?: Company[] | undefined;

  constructor(data?: IUpdateSession) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.firmwareId = _data["firmwareId"];
      this.firmware = _data["firmware"]
        ? Firmware.fromJS(_data["firmware"])
        : <any>undefined;
      this.succeeded = _data["succeeded"];
      this.startDate = _data["startDate"]
        ? new Date(_data["startDate"].toString())
        : <any>undefined;
      this.endDate = _data["endDate"]
        ? new Date(_data["endDate"].toString())
        : <any>undefined;
      if (Array.isArray(_data["companies"])) {
        this.companies = [] as any;
        for (let item of _data["companies"])
          this.companies!.push(Company.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdateSession {
    data = typeof data === "object" ? data : {};
    let result = new UpdateSession();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["firmwareId"] = this.firmwareId;
    data["firmware"] = this.firmware ? this.firmware.toJSON() : <any>undefined;
    data["succeeded"] = this.succeeded;
    data["startDate"] = this.startDate
      ? this.startDate.toISOString()
      : <any>undefined;
    data["endDate"] = this.endDate
      ? this.endDate.toISOString()
      : <any>undefined;
    if (Array.isArray(this.companies)) {
      data["companies"] = [];
      for (let item of this.companies) data["companies"].push(item.toJSON());
    }
    return data;
  }
}

export interface IUpdateSession {
  id?: string;
  firmwareId?: string;
  firmware?: Firmware;
  succeeded?: boolean | undefined;
  startDate?: Date;
  endDate?: Date | undefined;
  companies?: Company[] | undefined;
}

export class UpdateSessionDTO implements IUpdateSessionDTO {
  errors?: { [key: string]: string[] } | undefined;
  id?: string;
  firmwareId?: string;
  firmware?: Firmware;
  succeeded?: boolean | undefined;
  startDate?: Date;
  endDate?: Date | undefined;
  companiesSessions?: CompanyUpdateSessionDTO[] | undefined;

  constructor(data?: IUpdateSessionDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.firmwareId = _data["firmwareId"];
      this.firmware = _data["firmware"]
        ? Firmware.fromJS(_data["firmware"])
        : <any>undefined;
      this.succeeded = _data["succeeded"];
      this.startDate = _data["startDate"]
        ? new Date(_data["startDate"].toString())
        : <any>undefined;
      this.endDate = _data["endDate"]
        ? new Date(_data["endDate"].toString())
        : <any>undefined;
      if (Array.isArray(_data["companiesSessions"])) {
        this.companiesSessions = [] as any;
        for (let item of _data["companiesSessions"])
          this.companiesSessions!.push(CompanyUpdateSessionDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdateSessionDTO {
    data = typeof data === "object" ? data : {};
    let result = new UpdateSessionDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["firmwareId"] = this.firmwareId;
    data["firmware"] = this.firmware ? this.firmware.toJSON() : <any>undefined;
    data["succeeded"] = this.succeeded;
    data["startDate"] = this.startDate
      ? this.startDate.toISOString()
      : <any>undefined;
    data["endDate"] = this.endDate
      ? this.endDate.toISOString()
      : <any>undefined;
    if (Array.isArray(this.companiesSessions)) {
      data["companiesSessions"] = [];
      for (let item of this.companiesSessions)
        data["companiesSessions"].push(item.toJSON());
    }
    return data;
  }
}

export interface IUpdateSessionDTO {
  errors?: { [key: string]: string[] } | undefined;
  id?: string;
  firmwareId?: string;
  firmware?: Firmware;
  succeeded?: boolean | undefined;
  startDate?: Date;
  endDate?: Date | undefined;
  companiesSessions?: CompanyUpdateSessionDTO[] | undefined;
}

export class UpdateSessionDTOObjectResponseDTO
  implements IUpdateSessionDTOObjectResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: UpdateSessionDTO;

  constructor(data?: IUpdateSessionDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? UpdateSessionDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): UpdateSessionDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new UpdateSessionDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IUpdateSessionDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: UpdateSessionDTO;
}

export enum UploadStatus {
  Success = 1,
  Error = 2,
  Uploading = 3,
}

/** Пользователь */
export class UserDTO implements IUserDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор пользователя */
  id?: string;
  /** Имя пользователя (Никнейм) */
  userName!: string;
  /** Электронная почта */
  email!: string;
  /** Пароль */
  password?: string | undefined;
  /** Подтверждена или нет электронная почта */
  emailConfirmed?: boolean | undefined;
  /** Логин */
  login?: string | undefined;
  /** Имя */
  firstName?: string | undefined;
  /** Фамилия */
  secondName?: string | undefined;
  /** Дата рождения */
  dateBirth?: Date | undefined;
  gender?: Gender;
  /** Дата истечения refresh-токена */
  refreshTokenExpiryTime?: Date | undefined;
  /** Дата создания (регистрации) */
  creationDate?: Date | undefined;
  /** Список ролей */
  roles?: RoleDTO[] | undefined;
  /** Идентификатор компании */
  companyId?: string | undefined;

  constructor(data?: IUserDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.userName = _data["userName"];
      this.email = _data["email"];
      this.password = _data["password"];
      this.emailConfirmed = _data["emailConfirmed"];
      this.login = _data["login"];
      this.firstName = _data["firstName"];
      this.secondName = _data["secondName"];
      this.dateBirth = _data["dateBirth"]
        ? new Date(_data["dateBirth"].toString())
        : <any>undefined;
      this.gender = _data["gender"];
      this.refreshTokenExpiryTime = _data["refreshTokenExpiryTime"]
        ? new Date(_data["refreshTokenExpiryTime"].toString())
        : <any>undefined;
      this.creationDate = _data["creationDate"]
        ? new Date(_data["creationDate"].toString())
        : <any>undefined;
      if (Array.isArray(_data["roles"])) {
        this.roles = [] as any;
        for (let item of _data["roles"]) this.roles!.push(RoleDTO.fromJS(item));
      }
      this.companyId = _data["companyId"];
    }
  }

  static fromJS(data: any): UserDTO {
    data = typeof data === "object" ? data : {};
    let result = new UserDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["userName"] = this.userName;
    data["email"] = this.email;
    data["password"] = this.password;
    data["emailConfirmed"] = this.emailConfirmed;
    data["login"] = this.login;
    data["firstName"] = this.firstName;
    data["secondName"] = this.secondName;
    data["dateBirth"] = this.dateBirth
      ? this.dateBirth.toISOString()
      : <any>undefined;
    data["gender"] = this.gender;
    data["refreshTokenExpiryTime"] = this.refreshTokenExpiryTime
      ? this.refreshTokenExpiryTime.toISOString()
      : <any>undefined;
    data["creationDate"] = this.creationDate
      ? this.creationDate.toISOString()
      : <any>undefined;
    if (Array.isArray(this.roles)) {
      data["roles"] = [];
      for (let item of this.roles) data["roles"].push(item.toJSON());
    }
    data["companyId"] = this.companyId;
    return data;
  }
}

/** Пользователь */
export interface IUserDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор пользователя */
  id?: string;
  /** Имя пользователя (Никнейм) */
  userName: string;
  /** Электронная почта */
  email: string;
  /** Пароль */
  password?: string | undefined;
  /** Подтверждена или нет электронная почта */
  emailConfirmed?: boolean | undefined;
  /** Логин */
  login?: string | undefined;
  /** Имя */
  firstName?: string | undefined;
  /** Фамилия */
  secondName?: string | undefined;
  /** Дата рождения */
  dateBirth?: Date | undefined;
  gender?: Gender;
  /** Дата истечения refresh-токена */
  refreshTokenExpiryTime?: Date | undefined;
  /** Дата создания (регистрации) */
  creationDate?: Date | undefined;
  /** Список ролей */
  roles?: RoleDTO[] | undefined;
  /** Идентификатор компании */
  companyId?: string | undefined;
}

/** Действие пользователя (история действий) */
export class UserDTOActionHistoryDTO implements IUserDTOActionHistoryDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** IP-пользователя */
  ip?: string | undefined;
  actionType?: ActionType;
  /** Дата */
  date?: Date;
  data?: UserDTO;

  constructor(data?: IUserDTOActionHistoryDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.ip = _data["ip"];
      this.actionType = _data["actionType"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
      this.data = _data["data"]
        ? UserDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): UserDTOActionHistoryDTO {
    data = typeof data === "object" ? data : {};
    let result = new UserDTOActionHistoryDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["ip"] = this.ip;
    data["actionType"] = this.actionType;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

/** Действие пользователя (история действий) */
export interface IUserDTOActionHistoryDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** IP-пользователя */
  ip?: string | undefined;
  actionType?: ActionType;
  /** Дата */
  date?: Date;
  data?: UserDTO;
}

export class UserDTOActionHistoryDTOListResponseDTO
  implements IUserDTOActionHistoryDTOListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: UserDTOActionHistoryDTO[] | undefined;

  constructor(data?: IUserDTOActionHistoryDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(UserDTOActionHistoryDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UserDTOActionHistoryDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new UserDTOActionHistoryDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IUserDTOActionHistoryDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: UserDTOActionHistoryDTO[] | undefined;
}

export class UserDTOListResponseDTO implements IUserDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: UserDTO[] | undefined;

  constructor(data?: IUserDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"]) this.data!.push(UserDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UserDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new UserDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IUserDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: UserDTO[] | undefined;
}

export class UserDTOObjectResponseDTO implements IUserDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: UserDTO;

  constructor(data?: IUserDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? UserDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): UserDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new UserDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IUserDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: UserDTO;
}

/** Модель для входа в систему (аутентификация) */
export class UserLoginDTO implements IUserLoginDTO {
  /** Электронная почта */
  email!: string;
  /** Пароль */
  password!: string;

  constructor(data?: IUserLoginDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): UserLoginDTO {
    data = typeof data === "object" ? data : {};
    let result = new UserLoginDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["email"] = this.email;
    data["password"] = this.password;
    return data;
  }
}

/** Модель для входа в систему (аутентификация) */
export interface IUserLoginDTO {
  /** Электронная почта */
  email: string;
  /** Пароль */
  password: string;
}

/** Профиль пользователя */
export class UserProfileDTO implements IUserProfileDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** Логин */
  login!: string;
  /** Электронная почта */
  email!: string;
  /** Имя */
  firstName?: string | undefined;
  /** Фамилия */
  secondName?: string | undefined;
  /** Дата рождения */
  dateBirth?: Date;
  gender?: Gender;

  constructor(data?: IUserProfileDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.login = _data["login"];
      this.email = _data["email"];
      this.firstName = _data["firstName"];
      this.secondName = _data["secondName"];
      this.dateBirth = _data["dateBirth"]
        ? new Date(_data["dateBirth"].toString())
        : <any>undefined;
      this.gender = _data["gender"];
    }
  }

  static fromJS(data: any): UserProfileDTO {
    data = typeof data === "object" ? data : {};
    let result = new UserProfileDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["login"] = this.login;
    data["email"] = this.email;
    data["firstName"] = this.firstName;
    data["secondName"] = this.secondName;
    data["dateBirth"] = this.dateBirth
      ? this.dateBirth.toISOString()
      : <any>undefined;
    data["gender"] = this.gender;
    return data;
  }
}

/** Профиль пользователя */
export interface IUserProfileDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** Логин */
  login: string;
  /** Электронная почта */
  email: string;
  /** Имя */
  firstName?: string | undefined;
  /** Фамилия */
  secondName?: string | undefined;
  /** Дата рождения */
  dateBirth?: Date;
  gender?: Gender;
}

export class UserProfileDTOObjectResponseDTO
  implements IUserProfileDTOObjectResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: UserProfileDTO;

  constructor(data?: IUserProfileDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? UserProfileDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): UserProfileDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new UserProfileDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IUserProfileDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: UserProfileDTO;
}

/** Модель для регистрации */
export class UserRegisterDTO implements IUserRegisterDTO {
  /** Электронная почта */
  email!: string;
  /** Пароль */
  password!: string;
  /** Уникальный номер компании (токен) */
  companyToken!: string;

  constructor(data?: IUserRegisterDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data["email"];
      this.password = _data["password"];
      this.companyToken = _data["companyToken"];
    }
  }

  static fromJS(data: any): UserRegisterDTO {
    data = typeof data === "object" ? data : {};
    let result = new UserRegisterDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["email"] = this.email;
    data["password"] = this.password;
    data["companyToken"] = this.companyToken;
    return data;
  }
}

/** Модель для регистрации */
export interface IUserRegisterDTO {
  /** Электронная почта */
  email: string;
  /** Пароль */
  password: string;
  /** Уникальный номер компании (токен) */
  companyToken: string;
}

/** Транспортное средство */
export class VehicleDTO implements IVehicleDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** Уникальный идентификатор транспортного средства */
  uvi?: string | undefined;
  module?: ModuleDTO;
  /** Номер транспортного средства */
  licensyPlate?: string | undefined;
  /** VIN-код (Идентификационный номер транспортного средства) */
  vin?: string | undefined;
  /** Название */
  name!: string;
  coordinates?: Coordinates;
  /** Идентификатор типа транспортного средства */
  typeId?: number | undefined;
  /** Дата создания */
  creationDate?: Date;
  /** В архиве или нет (был удален или нет) */
  archived?: boolean;

  constructor(data?: IVehicleDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.uvi = _data["uvi"];
      this.module = _data["module"]
        ? ModuleDTO.fromJS(_data["module"])
        : <any>undefined;
      this.licensyPlate = _data["licensyPlate"];
      this.vin = _data["vin"];
      this.name = _data["name"];
      this.coordinates = _data["coordinates"]
        ? Coordinates.fromJS(_data["coordinates"])
        : <any>undefined;
      this.typeId = _data["typeId"];
      this.creationDate = _data["creationDate"]
        ? new Date(_data["creationDate"].toString())
        : <any>undefined;
      this.archived = _data["archived"];
    }
  }

  static fromJS(data: any): VehicleDTO {
    data = typeof data === "object" ? data : {};
    let result = new VehicleDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["uvi"] = this.uvi;
    data["module"] = this.module ? this.module.toJSON() : <any>undefined;
    data["licensyPlate"] = this.licensyPlate;
    data["vin"] = this.vin;
    data["name"] = this.name;
    data["coordinates"] = this.coordinates
      ? this.coordinates.toJSON()
      : <any>undefined;
    data["typeId"] = this.typeId;
    data["creationDate"] = this.creationDate
      ? this.creationDate.toISOString()
      : <any>undefined;
    data["archived"] = this.archived;
    return data;
  }
}

/** Транспортное средство */
export interface IVehicleDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** Уникальный идентификатор транспортного средства */
  uvi?: string | undefined;
  module?: ModuleDTO;
  /** Номер транспортного средства */
  licensyPlate?: string | undefined;
  /** VIN-код (Идентификационный номер транспортного средства) */
  vin?: string | undefined;
  /** Название */
  name: string;
  coordinates?: Coordinates;
  /** Идентификатор типа транспортного средства */
  typeId?: number | undefined;
  /** Дата создания */
  creationDate?: Date;
  /** В архиве или нет (был удален или нет) */
  archived?: boolean;
}

/** Действие пользователя (история действий) */
export class VehicleDTOActionHistoryDTO implements IVehicleDTOActionHistoryDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** IP-пользователя */
  ip?: string | undefined;
  actionType?: ActionType;
  /** Дата */
  date?: Date;
  data?: VehicleDTO;

  constructor(data?: IVehicleDTOActionHistoryDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.ip = _data["ip"];
      this.actionType = _data["actionType"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
      this.data = _data["data"]
        ? VehicleDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): VehicleDTOActionHistoryDTO {
    data = typeof data === "object" ? data : {};
    let result = new VehicleDTOActionHistoryDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["ip"] = this.ip;
    data["actionType"] = this.actionType;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

/** Действие пользователя (история действий) */
export interface IVehicleDTOActionHistoryDTO {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: string;
  /** IP-пользователя */
  ip?: string | undefined;
  actionType?: ActionType;
  /** Дата */
  date?: Date;
  data?: VehicleDTO;
}

export class VehicleDTOActionHistoryDTOListResponseDTO
  implements IVehicleDTOActionHistoryDTOListResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: VehicleDTOActionHistoryDTO[] | undefined;

  constructor(data?: IVehicleDTOActionHistoryDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(VehicleDTOActionHistoryDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): VehicleDTOActionHistoryDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new VehicleDTOActionHistoryDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IVehicleDTOActionHistoryDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: VehicleDTOActionHistoryDTO[] | undefined;
}

export class VehicleDTOListResponseDTO implements IVehicleDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: VehicleDTO[] | undefined;

  constructor(data?: IVehicleDTOListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(VehicleDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): VehicleDTOListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new VehicleDTOListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IVehicleDTOListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: VehicleDTO[] | undefined;
}

export class VehicleDTOObjectResponseDTO
  implements IVehicleDTOObjectResponseDTO
{
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: VehicleDTO;

  constructor(data?: IVehicleDTOObjectResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      this.data = _data["data"]
        ? VehicleDTO.fromJS(_data["data"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): VehicleDTOObjectResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new VehicleDTOObjectResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    data["data"] = this.data ? this.data.toJSON() : <any>undefined;
    return data;
  }
}

export interface IVehicleDTOObjectResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: VehicleDTO;
}

/** Тип транспортного средства */
export class VehicleType implements IVehicleType {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: number;
  /** Тип */
  type?: string | undefined;

  constructor(data?: IVehicleType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
      this.id = _data["id"];
      this.type = _data["type"];
    }
  }

  static fromJS(data: any): VehicleType {
    data = typeof data === "object" ? data : {};
    let result = new VehicleType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data["errors"])[key] = (<any>this.errors)[key];
      }
    }
    data["id"] = this.id;
    data["type"] = this.type;
    return data;
  }
}

/** Тип транспортного средства */
export interface IVehicleType {
  errors?: { [key: string]: string[] } | undefined;
  /** Идентификатор */
  id?: number;
  /** Тип */
  type?: string | undefined;
}

export class VehicleTypeListResponseDTO implements IVehicleTypeListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: VehicleType[] | undefined;

  constructor(data?: IVehicleTypeListResponseDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.succeeded = _data["succeeded"];
      this.message = _data["message"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(VehicleType.fromJS(item));
      }
    }
  }

  static fromJS(data: any): VehicleTypeListResponseDTO {
    data = typeof data === "object" ? data : {};
    let result = new VehicleTypeListResponseDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["succeeded"] = this.succeeded;
    data["message"] = this.message;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item.toJSON());
    }
    return data;
  }
}

export interface IVehicleTypeListResponseDTO {
  succeeded?: boolean;
  message?: string | undefined;
  errors?: string[] | undefined;
  data?: VehicleType[] | undefined;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
